"use strict";
var bundle;
var _learnq = _learnq || [];
var $ = jQuery.noConflict();

/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.5.9
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(d){"use strict";var s,l=window.Slick||{};s=0,(l=function(i,e){var t,o=this;o.defaults={adaptiveHeight:!1,appendArrows:d(i),appendDots:d(i),arrows:!0,arrowsPlacement:null,asNavFor:null,prevArrow:'<button class="slick-prev" type="button"><span class="slick-prev-icon" aria-hidden="true"></span><span class="slick-sr-only">Previous</span></button>',nextArrow:'<button class="slick-next" type="button"><span class="slick-next-icon" aria-hidden="true"></span><span class="slick-sr-only">Next</span></button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(i,e){return d('<button type="button"><span class="slick-dot-icon" aria-hidden="true"></span><span class="slick-sr-only">Go to slide '+(e+1)+"</span></button>")},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,infinite:!0,initialSlide:0,instructionsText:null,lazyLoad:"ondemand",mobileFirst:!1,playIcon:'<span class="slick-play-icon" aria-hidden="true"></span>',pauseIcon:'<span class="slick-pause-icon" aria-hidden="true"></span>',pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,regionLabel:"carousel",respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useAutoplayToggleButton:!0,useCSS:!0,useGroupRole:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},o.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,$instructionsText:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$pauseButton:null,$pauseIcon:null,$playIcon:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},d.extend(o,o.initials),o.activeBreakpoint=null,o.animType=null,o.animProp=null,o.breakpoints=[],o.breakpointSettings=[],o.cssTransitions=!1,o.focussed=!1,o.interrupted=!1,o.hidden="hidden",o.paused=!0,o.positionProp=null,o.respondTo=null,o.rowCount=1,o.shouldClick=!0,o.$slider=d(i),o.$slidesCache=null,o.transformType=null,o.transitionType=null,o.visibilityChange="visibilitychange",o.windowWidth=0,o.windowTimer=null,t=d(i).data("slick")||{},o.options=d.extend({},o.defaults,e,t),o.currentSlide=o.options.initialSlide,o.originalSettings=o.options,void 0!==document.mozHidden?(o.hidden="mozHidden",o.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(o.hidden="webkitHidden",o.visibilityChange="webkitvisibilitychange"),o.autoPlay=d.proxy(o.autoPlay,o),o.autoPlayClear=d.proxy(o.autoPlayClear,o),o.autoPlayIterator=d.proxy(o.autoPlayIterator,o),o.autoPlayToggleHandler=d.proxy(o.autoPlayToggleHandler,o),o.changeSlide=d.proxy(o.changeSlide,o),o.clickHandler=d.proxy(o.clickHandler,o),o.selectHandler=d.proxy(o.selectHandler,o),o.setPosition=d.proxy(o.setPosition,o),o.swipeHandler=d.proxy(o.swipeHandler,o),o.dragHandler=d.proxy(o.dragHandler,o),o.instanceUid=s++,o.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,o.registerBreakpoints(),o.init(!0)}).prototype.addSlide=l.prototype.slickAdd=function(i,e,t){var o=this;if("boolean"==typeof e)t=e,e=null;else if(e<0||e>=o.slideCount)return!1;o.unload(),"number"==typeof e?0===e&&0===o.$slides.length?d(i).appendTo(o.$slideTrack):t?d(i).insertBefore(o.$slides.eq(e)):d(i).insertAfter(o.$slides.eq(e)):!0===t?d(i).prependTo(o.$slideTrack):d(i).appendTo(o.$slideTrack),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slides.each(function(i,e){d(e).attr("data-slick-index",i),d(e).attr("role","group"),d(e).attr("aria-label","slide "+i)}),o.$slidesCache=o.$slides,o.reinit()},l.prototype.animateHeight=function(){var i,e=this;1===e.options.slidesToShow&&!0===e.options.adaptiveHeight&&!1===e.options.vertical&&(i=e.$slides.eq(e.currentSlide).outerHeight(!0),e.$list.animate({height:i},e.options.speed))},l.prototype.animateSlide=function(i,e){var t={},o=this;o.animateHeight(),!0===o.options.rtl&&!1===o.options.vertical&&(i=-i),!1===o.transformsEnabled?!1===o.options.vertical?o.$slideTrack.animate({left:i},o.options.speed,o.options.easing,e):o.$slideTrack.animate({top:i},o.options.speed,o.options.easing,e):!1===o.cssTransitions?(!0===o.options.rtl&&(o.currentLeft=-o.currentLeft),d({animStart:o.currentLeft}).animate({animStart:i},{duration:o.options.speed,easing:o.options.easing,step:function(i){i=Math.ceil(i),!1===o.options.vertical?t[o.animType]="translate("+i+"px, 0px)":t[o.animType]="translate(0px,"+i+"px)",o.$slideTrack.css(t)},complete:function(){e&&e.call()}})):(o.applyTransition(),i=Math.ceil(i),!1===o.options.vertical?t[o.animType]="translate3d("+i+"px, 0px, 0px)":t[o.animType]="translate3d(0px,"+i+"px, 0px)",o.$slideTrack.css(t),e&&setTimeout(function(){o.disableTransition(),e.call()},o.options.speed))},l.prototype.getNavTarget=function(){var i=this.options.asNavFor;return i&&null!==i&&(i=d(i).not(this.$slider)),i},l.prototype.asNavFor=function(e){var i=this.getNavTarget();null!==i&&"object"==typeof i&&i.each(function(){var i=d(this).slick("getSlick");i.unslicked||i.slideHandler(e,!0)})},l.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},l.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},l.prototype.autoPlayClear=function(){this.autoPlayTimer&&clearInterval(this.autoPlayTimer)},l.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},l.prototype.autoPlayToggleHandler=function(){var i=this;i.paused?(i.$playIcon.css("display","none"),i.$pauseIcon.css("display","inline"),i.$pauseButton.find(".slick-play-text").attr("style","display: none"),i.$pauseButton.find(".slick-pause-text").removeAttr("style"),i.slickPlay()):(i.$playIcon.css("display","inline"),i.$pauseIcon.css("display","none"),i.$pauseButton.find(".slick-play-text").removeAttr("style"),i.$pauseButton.find(".slick-pause-text").attr("style","display: none"),i.slickPause())},l.prototype.buildArrows=function(){var i=this;if(!0===i.options.arrows)if(i.$prevArrow=d(i.options.prevArrow).addClass("slick-arrow"),i.$nextArrow=d(i.options.nextArrow).addClass("slick-arrow"),i.slideCount>i.options.slidesToShow){if(i.htmlExpr.test(i.options.prevArrow))if(null!=i.options.arrowsPlacement)switch(i.options.arrowsPlacement){case"beforeSlides":case"split":i.$prevArrow.prependTo(i.options.appendArrows);break;case"afterSlides":i.$prevArrow.appendTo(i.options.appendArrows)}else i.$prevArrow.prependTo(i.options.appendArrows);if(i.htmlExpr.test(i.options.nextArrow))if(null!=i.options.arrowsPlacement)switch(i.options.arrowsPlacement){case"beforeSlides":i.$prevArrow.after(i.$nextArrow);break;case"afterSlides":case"split":i.$nextArrow.appendTo(i.options.appendArrows)}else i.$nextArrow.appendTo(i.options.appendArrows);!0!==i.options.infinite&&i.$prevArrow.addClass("slick-disabled").prop("disabled",!0)}else i.$prevArrow.add(i.$nextArrow).addClass("slick-hidden").prop("disabled",!0)},l.prototype.buildDots=function(){var i,e,t=this;if(!0===t.options.dots&&t.slideCount>t.options.slidesToShow){for(t.$slider.addClass("slick-dotted"),e=d("<ul />").addClass(t.options.dotsClass),i=0;i<=t.getDotCount();i+=1)e.append(d("<li />").append(t.options.customPaging.call(this,t,i)));t.$dots=e.appendTo(t.options.appendDots),t.$dots.find("li").first().addClass("slick-active")}},l.prototype.buildOut=function(){var t=this;t.$slides=t.$slider.children(t.options.slide+":not(.slick-cloned)").addClass("slick-slide"),t.slideCount=t.$slides.length,t.$slides.each(function(i,e){d(e).attr("data-slick-index",i).data("originalStyling",d(e).attr("style")||""),t.options.useGroupRole&&d(e).attr("role","group").attr("aria-label","slide "+(i+1))}),t.$slider.addClass("slick-slider"),t.$slider.addClass("accessible-slick"),t.$slider.attr("role","region"),t.$slider.attr("aria-label",t.options.regionLabel),t.$slider.attr("tabindex",-1),t.$slideTrack=0===t.slideCount?d('<div class="slick-track"/>').appendTo(t.$slider):t.$slides.wrapAll('<div class="slick-track"/>').parent(),t.$list=t.$slideTrack.wrap('<div class="slick-list"/>').parent(),t.$slideTrack.css("opacity",0),!0!==t.options.centerMode&&!0!==t.options.swipeToSlide||(t.options.slidesToScroll=1),d("img[data-lazy]",t.$slider).not("[src]").addClass("slick-loading"),t.setupInfinite(),t.buildArrows(),t.buildDots(),t.updateDots(),t.setSlideClasses("number"==typeof t.currentSlide?t.currentSlide:0),!0===t.options.draggable&&t.$list.addClass("draggable"),t.options.autoplay&&t.options.useAutoplayToggleButton&&(t.$pauseIcon=d(t.options.pauseIcon).attr("aria-hidden",!0),t.$playIcon=d(t.options.playIcon).attr("aria-hidden",!0),t.$pauseButton=d('<button type="button" class="slick-autoplay-toggle-button">'),t.$pauseButton.append(t.$pauseIcon),t.$pauseButton.append(t.$playIcon.css("display","none")),t.$pauseButton.append(d('<span class="slick-pause-text slick-sr-only">Pause</span>')),t.$pauseButton.append(d('<span class="slick-play-text slick-sr-only" style="display: none">Play</span>')),t.$pauseButton.prependTo(t.$slider)),null!=t.options.instructionsText&&""!=t.options.instructionsText&&(t.$instructionsText=d('<p class="slick-instructions slick-sr-only">'+t.options.instructionsText+"</p>"),t.$instructionsText.prependTo(t.$slider))},l.prototype.buildRows=function(){var i,e,t,o=this,s=document.createDocumentFragment(),n=o.$slider.children();if(0<o.options.rows){for(t=o.options.slidesPerRow*o.options.rows,e=Math.ceil(n.length/t),i=0;i<e;i++){for(var l=document.createElement("div"),r=0;r<o.options.rows;r++){for(var a=document.createElement("div"),d=0;d<o.options.slidesPerRow;d++){var p=i*t+(r*o.options.slidesPerRow+d);n.get(p)&&a.appendChild(n.get(p))}l.appendChild(a)}s.appendChild(l)}o.$slider.empty().append(s),o.$slider.children().children().children().css({width:100/o.options.slidesPerRow+"%",display:"inline-block"})}},l.prototype.checkResponsive=function(i,e){var t,o,s,n=this,l=!1,r=n.$slider.width(),a=window.innerWidth||d(window).width();if("window"===n.respondTo?s=a:"slider"===n.respondTo?s=r:"min"===n.respondTo&&(s=Math.min(a,r)),n.options.responsive&&n.options.responsive.length&&null!==n.options.responsive){for(t in o=null,n.breakpoints)n.breakpoints.hasOwnProperty(t)&&(!1===n.originalSettings.mobileFirst?s<n.breakpoints[t]&&(o=n.breakpoints[t]):s>n.breakpoints[t]&&(o=n.breakpoints[t]));null!==o?null!==n.activeBreakpoint&&o===n.activeBreakpoint&&!e||(n.activeBreakpoint=o,"unslick"===n.breakpointSettings[o]?n.unslick(o):(n.options=d.extend({},n.originalSettings,n.breakpointSettings[o]),!0===i&&(n.currentSlide=n.options.initialSlide),n.refresh(i)),l=o):null!==n.activeBreakpoint&&(n.activeBreakpoint=null,n.options=n.originalSettings,!0===i&&(n.currentSlide=n.options.initialSlide),n.refresh(i),l=o),i||!1===l||n.$slider.trigger("breakpoint",[n,l])}},l.prototype.changeSlide=function(i,e){var t,o,s=this,n=d(i.currentTarget);switch(n.is("a")&&i.preventDefault(),n.is("li")||(n=n.closest("li")),t=s.slideCount%s.options.slidesToScroll!=0?0:(s.slideCount-s.currentSlide)%s.options.slidesToScroll,i.data.message){case"previous":o=0==t?s.options.slidesToScroll:s.options.slidesToShow-t,s.slideCount>s.options.slidesToShow&&s.slideHandler(s.currentSlide-o,!1,e);break;case"next":o=0==t?s.options.slidesToScroll:t,s.slideCount>s.options.slidesToShow&&s.slideHandler(s.currentSlide+o,!1,e);break;case"index":var l=0===i.data.index?0:i.data.index||n.index()*s.options.slidesToScroll;s.slideHandler(s.checkNavigable(l),!1,e),n.children().trigger("focus");break;default:return}},l.prototype.checkNavigable=function(i){var e=this.getNavigableIndexes(),t=0;if(i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},l.prototype.cleanUpEvents=function(){var i=this;i.options.autoplay&&i.options.useAutoplayToggleButton&&i.$pauseButton.off("click.slick",i.autoPlayToggleHandler),i.options.dots&&null!==i.$dots&&d("li",i.$dots).off("click.slick",i.changeSlide).off("mouseenter.slick",d.proxy(i.interrupt,i,!0)).off("mouseleave.slick",d.proxy(i.interrupt,i,!1)),i.$slider.off("focus.slick blur.slick"),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow&&i.$prevArrow.off("click.slick",i.changeSlide),i.$nextArrow&&i.$nextArrow.off("click.slick",i.changeSlide)),i.$list.off("touchstart.slick mousedown.slick",i.swipeHandler),i.$list.off("touchmove.slick mousemove.slick",i.swipeHandler),i.$list.off("touchend.slick mouseup.slick",i.swipeHandler),i.$list.off("touchcancel.slick mouseleave.slick",i.swipeHandler),i.$list.off("click.slick",i.clickHandler),d(document).off(i.visibilityChange,i.visibility),i.cleanUpSlideEvents(),d(window).off("orientationchange.slick.slick-"+i.instanceUid,i.orientationChange),d(window).off("resize.slick.slick-"+i.instanceUid,i.resize),d("[draggable!=true]",i.$slideTrack).off("dragstart",i.preventDefault),d(window).off("load.slick.slick-"+i.instanceUid,i.setPosition)},l.prototype.cleanUpSlideEvents=function(){var i=this;i.$list.off("mouseenter.slick",d.proxy(i.interrupt,i,!0)),i.$list.off("mouseleave.slick",d.proxy(i.interrupt,i,!1))},l.prototype.cleanUpRows=function(){var i;0<this.options.rows&&((i=this.$slides.children().children()).removeAttr("style"),this.$slider.empty().append(i))},l.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},l.prototype.destroy=function(i){var e=this;e.autoPlayClear(),e.touchObject={},e.cleanUpEvents(),d(".slick-cloned",e.$slider).detach(),e.options.autoplay&&e.options.useAutoplayToggleButton&&e.$pauseButton.remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.$prevArrow.length&&(e.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").prop("disabled",!1).css("display",""),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove()),e.$nextArrow&&e.$nextArrow.length&&(e.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").prop("disabled",!1).css("display",""),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove()),e.$slides&&(e.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){d(this).attr("style",d(this).data("originalStyling"))}),e.$slideTrack.children(this.options.slide).detach(),e.$slideTrack.detach(),e.$list.detach(),e.$slider.append(e.$slides)),e.cleanUpRows(),e.$slider.removeClass("slick-slider"),e.$slider.removeClass("slick-initialized"),e.$slider.removeClass("slick-dotted"),e.$slider.removeClass("accessible-slick"),e.unslicked=!0,i||e.$slider.trigger("destroy",[e])},l.prototype.disableTransition=function(i){var e={};e[this.transitionType]="",!1===this.options.fade?this.$slideTrack.css(e):this.$slides.eq(i).css(e)},l.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},l.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},l.prototype.filterSlides=l.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},l.prototype.focusHandler=function(){var t=this;t.$slider.off("focus.slick blur.slick").on("focus.slick","*",function(i){var e=d(this);setTimeout(function(){t.options.pauseOnFocus&&e.is(":focus")&&(t.focussed=!0,t.autoPlay())},0)}).on("blur.slick","*",function(i){d(this);t.options.pauseOnFocus&&(t.focussed=!1,t.autoPlay())})},l.prototype.getCurrent=l.prototype.slickCurrentSlide=function(){return this.currentSlide},l.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},l.prototype.getLeft=function(i){var e,t,o,s,n=this,l=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),l=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(l=i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,l=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(l=n.slideOffset=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+l,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},l.prototype.getOption=l.prototype.slickGetOption=function(i){return this.options[i]},l.prototype.getNavigableIndexes=function(){for(var i=this,e=0,t=0,o=[],s=!1===i.options.infinite?i.slideCount:(e=-1*i.options.slidesToScroll,t=-1*i.options.slidesToScroll,2*i.slideCount);e<s;)o.push(e),e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;return o},l.prototype.getSlick=function(){return this},l.prototype.getSlideCount=function(){var s,n=this,i=!0===n.options.centerMode?Math.floor(n.$list.width()/2):0,l=-1*n.swipeLeft+i;return!0===n.options.swipeToSlide?(n.$slideTrack.find(".slick-slide").each(function(i,e){var t=d(e).outerWidth(),o=e.offsetLeft;if(!0!==n.options.centerMode&&(o+=t/2),l<o+t)return s=e,!1}),Math.abs(d(s).attr("data-slick-index")-n.currentSlide)||1):n.options.slidesToScroll},l.prototype.goTo=l.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},l.prototype.init=function(i){var e=this;d(e.$slider).hasClass("slick-initialized")||(d(e.$slider).addClass("slick-initialized"),e.buildRows(),e.buildOut(),e.setProps(),e.startLoad(),e.loadSlider(),e.initializeEvents(),e.updateArrows(),e.updateDots(),e.checkResponsive(!0),e.focusHandler()),i&&e.$slider.trigger("init",[e]),e.options.autoplay&&(e.paused=!1,e.autoPlay()),e.updateSlideVisibility(),null!=e.options.accessibility&&console.warn("accessibility setting is no longer supported."),null!=e.options.focusOnChange&&console.warn("focusOnChange is no longer supported."),null!=e.options.focusOnSelect&&console.warn("focusOnSelect is no longer supported.")},l.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide))},l.prototype.initDotEvents=function(){var i=this;!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&d("li",i.$dots).on("click.slick",{message:"index"},i.changeSlide),!0===i.options.dots&&!0===i.options.pauseOnDotsHover&&i.slideCount>i.options.slidesToShow&&d("li",i.$dots).on("mouseenter.slick",d.proxy(i.interrupt,i,!0)).on("mouseleave.slick",d.proxy(i.interrupt,i,!1))},l.prototype.initSlideEvents=function(){var i=this;i.options.pauseOnHover&&(i.$list.on("mouseenter.slick",d.proxy(i.interrupt,i,!0)),i.$list.on("mouseleave.slick",d.proxy(i.interrupt,i,!1)))},l.prototype.initializeEvents=function(){var i=this;i.initArrowEvents(),i.initDotEvents(),i.initSlideEvents(),i.options.autoplay&&i.options.useAutoplayToggleButton&&i.$pauseButton.on("click.slick",i.autoPlayToggleHandler),i.$list.on("touchstart.slick mousedown.slick",{action:"start"},i.swipeHandler),i.$list.on("touchmove.slick mousemove.slick",{action:"move"},i.swipeHandler),i.$list.on("touchend.slick mouseup.slick",{action:"end"},i.swipeHandler),i.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},i.swipeHandler),i.$list.on("click.slick",i.clickHandler),d(document).on(i.visibilityChange,d.proxy(i.visibility,i)),d(window).on("orientationchange.slick.slick-"+i.instanceUid,d.proxy(i.orientationChange,i)),d(window).on("resize.slick.slick-"+i.instanceUid,d.proxy(i.resize,i)),d("[draggable!=true]",i.$slideTrack).on("dragstart",i.preventDefault),d(window).on("load.slick.slick-"+i.instanceUid,i.setPosition),d(i.setPosition)},l.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},l.prototype.lazyLoad=function(){var i,e,t,n=this;function o(i){d("img[data-lazy]",i).each(function(){var i=d(this),e=d(this).attr("data-lazy"),t=d(this).attr("data-srcset"),o=d(this).attr("data-sizes")||n.$slider.attr("data-sizes"),s=document.createElement("img");s.onload=function(){i.animate({opacity:0},100,function(){t&&(i.attr("srcset",t),o&&i.attr("sizes",o)),i.attr("src",e).animate({opacity:1},200,function(){i.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,i,e])})},s.onerror=function(){i.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,i,e])},s.src=e})}if(!0===n.options.centerMode?t=!0===n.options.infinite?(e=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(e=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),n.options.slidesToShow/2+1+2+n.currentSlide):(e=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,t=Math.ceil(e+n.options.slidesToShow),!0===n.options.fade&&(0<e&&e--,t<=n.slideCount&&t++)),i=n.$slider.find(".slick-slide").slice(e,t),"anticipated"===n.options.lazyLoad)for(var s=e-1,l=t,r=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)s<0&&(s=n.slideCount-1),i=(i=i.add(r.eq(s))).add(r.eq(l)),s--,l++;o(i),n.slideCount<=n.options.slidesToShow?o(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?o(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&o(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},l.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},l.prototype.next=l.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},l.prototype.orientationChange=function(){this.checkResponsive(),this.setPosition()},l.prototype.pause=l.prototype.slickPause=function(){this.autoPlayClear(),this.paused=!0},l.prototype.play=l.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},l.prototype.postSlide=function(i){var e=this;e.unslicked||(e.$slider.trigger("afterChange",[e,i]),e.animating=!1,e.slideCount>e.options.slidesToShow&&e.setPosition(),e.swipeLeft=null,e.options.autoplay&&e.autoPlay(),e.updateSlideVisibility())},l.prototype.prev=l.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},l.prototype.preventDefault=function(i){i.preventDefault()},l.prototype.progressiveLazyLoad=function(i){i=i||1;var e,t,o,s,n,l=this,r=d("img[data-lazy]",l.$slider);r.length?(e=r.first(),t=e.attr("data-lazy"),o=e.attr("data-srcset"),s=e.attr("data-sizes")||l.$slider.attr("data-sizes"),(n=document.createElement("img")).onload=function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,e,t]),l.progressiveLazyLoad()},n.onerror=function(){i<3?setTimeout(function(){l.progressiveLazyLoad(i+1)},500):(e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,e,t]),l.progressiveLazyLoad())},n.src=t):l.$slider.trigger("allImagesLoaded",[l])},l.prototype.refresh=function(i){var e,t=this,o=t.slideCount-t.options.slidesToShow;!t.options.infinite&&t.currentSlide>o&&(t.currentSlide=o),t.slideCount<=t.options.slidesToShow&&(t.currentSlide=0),e=t.currentSlide,t.destroy(!0),d.extend(t,t.initials,{currentSlide:e}),t.init(),i||t.changeSlide({data:{message:"index",index:e}},!1)},l.prototype.registerBreakpoints=function(){var i,e,t,o=this,s=o.options.responsive||null;if("array"===d.type(s)&&s.length){for(i in o.respondTo=o.options.respondTo||"window",s)if(t=o.breakpoints.length-1,s.hasOwnProperty(i)){for(e=s[i].breakpoint;0<=t;)o.breakpoints[t]&&o.breakpoints[t]===e&&o.breakpoints.splice(t,1),t--;o.breakpoints.push(e),o.breakpointSettings[e]=s[i].settings}o.breakpoints.sort(function(i,e){return o.options.mobileFirst?i-e:e-i})}},l.prototype.reinit=function(){var i=this;i.$slides=i.$slideTrack.children(i.options.slide).addClass("slick-slide"),i.slideCount=i.$slides.length,i.currentSlide>=i.slideCount&&0!==i.currentSlide&&(i.currentSlide=i.currentSlide-i.options.slidesToScroll),i.slideCount<=i.options.slidesToShow&&(i.currentSlide=0),i.registerBreakpoints(),i.setProps(),i.setupInfinite(),i.buildArrows(),i.updateArrows(),i.initArrowEvents(),i.buildDots(),i.updateDots(),i.initDotEvents(),i.cleanUpSlideEvents(),i.initSlideEvents(),i.checkResponsive(!1,!0),i.setSlideClasses("number"==typeof i.currentSlide?i.currentSlide:0),i.setPosition(),i.focusHandler(),i.paused=!i.options.autoplay,i.autoPlay(),i.$slider.trigger("reInit",[i])},l.prototype.resize=function(){var i=this;d(window).width()!==i.windowWidth&&(clearTimeout(i.windowDelay),i.windowDelay=window.setTimeout(function(){i.windowWidth=d(window).width(),i.checkResponsive(),i.unslicked||i.setPosition()},50))},l.prototype.removeSlide=l.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},l.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled||(!(s={})===o.cssTransitions?s[o.animType]="translate("+e+", "+t+")":s[o.animType]="translate3d("+e+", "+t+", 0px)"),o.$slideTrack.css(s)},l.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},l.prototype.setFade=function(){var t,o=this;o.$slides.each(function(i,e){t=o.slideWidth*i*-1,!0===o.options.rtl?d(e).css({position:"relative",right:t,top:0,zIndex:o.options.zIndex-2,opacity:0}):d(e).css({position:"relative",left:t,top:0,zIndex:o.options.zIndex-2,opacity:0})}),o.$slides.eq(o.currentSlide).css({zIndex:o.options.zIndex-1,opacity:1})},l.prototype.setHeight=function(){var i,e=this;1===e.options.slidesToShow&&!0===e.options.adaptiveHeight&&!1===e.options.vertical&&(i=e.$slides.eq(e.currentSlide).outerHeight(!0),e.$list.css("height",i))},l.prototype.setOption=l.prototype.slickSetOption=function(){var i,e,t,o,s,n=this,l=!1;if("object"===d.type(arguments[0])?(t=arguments[0],l=arguments[1],s="multiple"):"string"===d.type(arguments[0])&&(o=arguments[1],l=arguments[2],"responsive"===(t=arguments[0])&&"array"===d.type(arguments[1])?s="responsive":void 0!==arguments[1]&&(s="single")),"single"===s)n.options[t]=o;else if("multiple"===s)d.each(t,function(i,e){n.options[i]=e});else if("responsive"===s)for(e in o)if("array"!==d.type(n.options.responsive))n.options.responsive=[o[e]];else{for(i=n.options.responsive.length-1;0<=i;)n.options.responsive[i].breakpoint===o[e].breakpoint&&n.options.responsive.splice(i,1),i--;n.options.responsive.push(o[e])}l&&(n.unload(),n.reinit())},l.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},l.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},l.prototype.setSlideClasses=function(i){var e,t,o,s,n=this,l=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true");!1!==n.options.useGroupRole&&!0===n.options.centerMode&&l.attr("aria-label",function(){return d(this).attr("aria-label").replace(" (centered)","")}),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode?(o=n.options.slidesToShow%2==0?1:0,s=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(s<=i&&i<=n.slideCount-1-s?n.$slides.slice(i-s+o,i+s+1).addClass("slick-active").removeAttr("aria-hidden"):(e=n.options.slidesToShow+i,l.slice(e-s+1+o,e+s+2).addClass("slick-active").removeAttr("aria-hidden")),0===i?l.eq(n.options.slidesToShow+n.slideCount+1).addClass("slick-center").attr("aria-label",function(){return d(this).attr("aria-label")+" (centered)"}):i===n.slideCount-1&&l.eq(n.options.slidesToShow).addClass("slick-center").attr("aria-label",function(){return d(this).attr("aria-label")+" (centered)"})),n.$slides.eq(i).addClass("slick-center").attr("aria-label",function(){return d(this).attr("aria-label")+" (centered)"})):0<=i&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").removeAttr("aria-hidden"):l.length<=n.options.slidesToShow?l.addClass("slick-active").removeAttr("aria-hidden"):(t=n.slideCount%n.options.slidesToShow,e=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?l.slice(e-(n.options.slidesToShow-t),e+t).addClass("slick-active").removeAttr("aria-hidden"):l.slice(e,e+n.options.slidesToShow).addClass("slick-active").removeAttr("aria-hidden")),"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},l.prototype.setupInfinite=function(){var i,e,t,o=this;if(!0===o.options.fade&&(o.options.centerMode=!1),!0===o.options.infinite&&!1===o.options.fade&&(e=null,o.slideCount>o.options.slidesToShow)){for(t=!0===o.options.centerMode?o.options.slidesToShow+1:o.options.slidesToShow,i=o.slideCount;i>o.slideCount-t;--i)e=i-1,d(o.$slides[e]).clone(!0).removeAttr("id").attr("data-slick-index",e-o.slideCount).prependTo(o.$slideTrack).addClass("slick-cloned");for(i=0;i<t+o.slideCount;i+=1)e=i,d(o.$slides[e]).clone(!0).removeAttr("id").attr("data-slick-index",e+o.slideCount).appendTo(o.$slideTrack).addClass("slick-cloned");o.$slideTrack.find(".slick-cloned").find("[id]").each(function(){d(this).removeAttr("id")})}},l.prototype.interrupt=function(i){i||this.autoPlay(),this.interrupted=i},l.prototype.selectHandler=function(i){var e=d(i.target).is(".slick-slide")?d(i.target):d(i.target).parents(".slick-slide"),t=(t=parseInt(e.attr("data-slick-index")))||0;this.slideCount<=this.options.slidesToShow?this.slideHandler(t,!1,!0):this.slideHandler(t)},l.prototype.slideHandler=function(i,e,t){var o,s,n,l,r,a,d=this;if(e=e||!1,!(!0===d.animating&&!0===d.options.waitForAnimate||!0===d.options.fade&&d.currentSlide===i))if(!1===e&&d.asNavFor(i),o=i,r=d.getLeft(o),l=d.getLeft(d.currentSlide),d.currentLeft=null===d.swipeLeft?l:d.swipeLeft,!1===d.options.infinite&&!1===d.options.centerMode&&(i<0||i>d.getDotCount()*d.options.slidesToScroll))!1===d.options.fade&&(o=d.currentSlide,!0!==t&&d.slideCount>d.options.slidesToShow?d.animateSlide(l,function(){d.postSlide(o)}):d.postSlide(o));else if(!1===d.options.infinite&&!0===d.options.centerMode&&(i<0||i>d.slideCount-d.options.slidesToScroll))!1===d.options.fade&&(o=d.currentSlide,!0!==t&&d.slideCount>d.options.slidesToShow?d.animateSlide(l,function(){d.postSlide(o)}):d.postSlide(o));else{if(d.options.autoplay&&clearInterval(d.autoPlayTimer),s=o<0?d.slideCount%d.options.slidesToScroll!=0?d.slideCount-d.slideCount%d.options.slidesToScroll:d.slideCount+o:o>=d.slideCount?d.slideCount%d.options.slidesToScroll!=0?0:o-d.slideCount:o,d.animating=!0,d.$slider.trigger("beforeChange",[d,d.currentSlide,s]),n=d.currentSlide,d.currentSlide=s,d.setSlideClasses(d.currentSlide),d.options.asNavFor&&(a=(a=d.getNavTarget()).slick("getSlick")).slideCount<=a.options.slidesToShow&&a.setSlideClasses(d.currentSlide),d.updateDots(),d.updateArrows(),!0===d.options.fade)return!0!==t?(d.fadeSlideOut(n),d.fadeSlide(s,function(){d.postSlide(s)})):d.postSlide(s),void d.animateHeight();!0!==t&&d.slideCount>d.options.slidesToShow?d.animateSlide(r,function(){d.postSlide(s)}):d.postSlide(s)}},l.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},l.prototype.swipeDirection=function(){var i=this,e=i.touchObject.startX-i.touchObject.curX,t=i.touchObject.startY-i.touchObject.curY,o=Math.atan2(t,e),s=Math.round(180*o/Math.PI);return s<0&&(s=360-Math.abs(s)),s<=45&&0<=s||s<=360&&315<=s?!1===i.options.rtl?"left":"right":135<=s&&s<=225?!1===i.options.rtl?"right":"left":!0===i.options.verticalSwiping?35<=s&&s<=135?"down":"up":"vertical"},l.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1;if(o.interrupted=!1,o.shouldClick=!(10<o.touchObject.swipeLength),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},l.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},l.prototype.swipeMove=function(i){var e,t,o,s,n,l=this,r=void 0!==i.originalEvent?i.originalEvent.touches:null;return!(!l.dragging||l.scrolling||r&&1!==r.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==r?r[0].pageX:i.clientX,l.touchObject.curY=void 0!==r?r[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),n=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&4<n?!(l.scrolling=!0):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=n),t=l.swipeDirection(),void 0!==i.originalEvent&&4<l.touchObject.swipeLength&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,(l.touchObject.edgeHit=!1)===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},l.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return!(t.touchObject={});void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},l.prototype.unfilterSlides=l.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},l.prototype.unload=function(){var i=this;d(".slick-cloned",i.$slider).remove(),i.$dots&&i.$dots.remove(),i.$prevArrow&&i.htmlExpr.test(i.options.prevArrow)&&i.$prevArrow.remove(),i.$nextArrow&&i.htmlExpr.test(i.options.nextArrow)&&i.$nextArrow.remove(),i.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},l.prototype.unslick=function(i){this.$slider.trigger("unslick",[this,i]),this.destroy()},l.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2);!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").prop("disabled",!1),i.$nextArrow.removeClass("slick-disabled").prop("disabled",!1),0===i.currentSlide?(document.activeElement===i.$prevArrow.get(0)&&i.$slider.get(0).focus(),i.$prevArrow.addClass("slick-disabled").prop("disabled",!0),i.$nextArrow.removeClass("slick-disabled").prop("disabled",!1)):(i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode||i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode)&&(document.activeElement===i.$nextArrow.get(0)&&i.$slider.get(0).focus(),i.$nextArrow.addClass("slick-disabled").prop("disabled",!0),i.$prevArrow.removeClass("slick-disabled").prop("disabled",!1)))},l.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").find("button").removeAttr("aria-current").end().end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active").find("button").attr("aria-current",!0).end().end())},l.prototype.updateSlideVisibility=function(){this.$slideTrack.find(".slick-slide").attr("aria-hidden","true").find("a, input, button, select").attr("tabindex","-1"),this.$slideTrack.find(".slick-active").removeAttr("aria-hidden").find("a, input, button, select").removeAttr("tabindex")},l.prototype.visibility=function(){this.options.autoplay&&(document[this.hidden]?this.interrupted=!0:this.interrupted=!1)},d.fn.slick=function(){for(var i,e=this,t=arguments[0],o=Array.prototype.slice.call(arguments,1),s=e.length,n=0;n<s;n++)if("object"==typeof t||void 0===t?e[n].slick=new l(e[n],t):i=e[n].slick[t].apply(e[n].slick,o),void 0!==i)return i;return e}});

/*const { fetch: originalFetch } = window;
window.fetch = async (...args) => {
    let [resource, config ] = args;

    // request interceptor starts
    console.log('resource: ');
    console.log(resource);
    console.log(config);
    // request interceptor ends

    const response = await originalFetch(resource, config);

    // response interceptor here
    return response;
};*/

/* variables */
var header_menu_timeout = 500,
    header_menu_delay = 200;

/* product hover */
function initProductHover() {
    // $(document).on('mouseenter mouseleave', '#pageContent .product', function(e) {
    //   var $this = $(this),
    //       windW = window.innerWidth,
    //       tabsObj = $('.tabs-wrapper');

    //   if ($this.parents('.product-listing').hasClass('row-view')) return;
    //   else if ($this.parents().hasClass('modal-quick-view')) return;
    //   if ($this.hasClass('no-hover')) return;

    //   if (e.type === 'mouseenter' && windW >= 1300) {
    //     $this.css({
    //       height: $this.innerHeight()
    //     }).addClass('hovered').closest(tabsObj).addClass('select-block');
    //     $('body').addClass('hover-product');
    //   } else if (e.type === 'mouseleave' && e.relatedTarget) {
    //     $this.removeClass('hovered').removeAttr('style').closest(tabsObj).removeClass('select-block');
    //     $('body').removeClass('hover-product');
    //   }
    // });
};

if ($('.product').length) {
    initProductHover();
}

setTimeout(function () {

    if ($('.swatches-container .form-control.select-inline').length) {
        $('.swatches-container .form-control.select-inline').trigger('change');
    }
}, 400);

// Price Slider initialize
function priceSlider() {
    if ($('.priceSlider').length) {

        var priceSlider = document.getElementsByClassName('priceSlider')[0];

        noUiSlider.create(priceSlider, {
            start: [100, 900],
            connect: true,
            tooltips: true,
            step: 1,
            range: {
                'min': 0,
                'max': 1000
            }
        });

        var inputPriceMax = document.getElementById('priceMax');
        var inputPriceMin = document.getElementById('priceMin');

        priceSlider.noUiSlider.on('update', function (values, handle) {

            var value = values[handle];

            if (handle) {
                inputPriceMax.value = value;
            } else {
                inputPriceMin.value = value;
            }
        });

        inputPriceMax.addEventListener('change', function () {
            priceSlider.noUiSlider.set([null, this.value]);
        });
        inputPriceMin.addEventListener('change', function () {
            priceSlider.noUiSlider.set([this.value, null]);
        });
    }
    ;

}

// Countdown
function countDown(showZero) {
    if ($(".countdown").length) {

        var showZero = showZero || false;

        $(".countdown").each(function () {
            var $this = $(this),
                date = $this.data('date'),
                nextYear = false,
                tz = $('[name=timezone]');

            if (typeof moment === "function" && tz.length) nextYear = moment.tz($this.data('date'), tz.attr('content'));

            if (date = date.split('-')) {
                date = date.join('/');
            } else return;

            var timezone = nextYear ? nextYear.toDate() : date;

            $this.countdown(timezone, function (e) {
                var format = '<span class="countdown-row">';

                function addFormat(func, timeNum, showZero) {
                    if (timeNum === 0 && !showZero) return;

                    func(format);
                };

                addFormat(function () {
                    format += '<span class="countdown-section">'
                        + '<span class="countdown-amount">' + e.offset.totalDays + '</span>'
                        + '<span class="countdown-period">' + set_day + '</span>'
                        + '</span>';
                }, e.offset.totalDays, showZero);

                addFormat(function () {
                    format += '<span class="countdown-section">'
                        + '<span class="countdown-amount">' + e.offset.hours + '</span>'
                        + '<span class="countdown-period">' + set_hour + '</span>'
                        + '</span>';
                }, e.offset.hours, showZero);

                addFormat(function () {
                    format += '<span class="countdown-section">'
                        + '<span class="countdown-amount">' + e.offset.minutes + '</span>'
                        + '<span class="countdown-period">' + set_minute + '</span>'
                        + '</span>';
                }, e.offset.minutes, showZero);

                addFormat(function () {
                    format += '<span class="countdown-section">'
                        + '<span class="countdown-amount">' + e.offset.seconds + '</span>'
                        + '<span class="countdown-period">' + set_second + '</span>'
                        + '</span>';
                }, e.offset.seconds, showZero);

                format += '</span>';

                $(this).html(format);
            });
        });
    }
};

//product Small
function productSmall() {
    if ($("#pageContent .product").length > 0) {
        var currentItem = $("#pageContent  .product"),
            currentW = parseInt(currentItem.width());
        if (currentW <= 209) {
            currentItem.addClass("small");
        } else {
            currentItem.removeClass("small");
        }
        if (currentW <= 140) {
            currentItem.addClass("small-xs");
        } else {
            currentItem.removeClass("small-xs");
        }
    }
}

$(window).on('load resize', productSmall);


function carousel(value) {
    var windowW = window.innerWidth || $(window).width();
    var arr = $.makeArray(arguments);

    var slidesToShowXl = (arr[1] > 0) ? arr[1] : 6; //numberXl
    var slidesToShowLg = (arr[2] > 0) ? arr[2] : 4; //numberLg
    var slidesToShowMd = (arr[3] > 0) ? arr[3] : arr[2]; //numberMd
    var slidesToShowSm = (arr[4] > 0) ? arr[4] : arr[3]; //numberSm
    var slidesToShowXs = (arr[5] > 0) ? arr[5] : 1; //numberXs

    var speed = 500;

    value.slick({
        slidesToShow: slidesToShowXl,
        slidesToScroll: 1,
        speed: speed,

        responsive: [{
            breakpoint: 1770,
            settings: {
                slidesToShow: slidesToShowLg,
                slidesToScroll: slidesToShowLg
            }
        }, {
            breakpoint: 1199,
            settings: {
                slidesToShow: slidesToShowMd,
                slidesToScroll: slidesToShowMd
            }
        }, {
            breakpoint: 798,
            settings: {
                slidesToShow: slidesToShowSm,
                slidesToScroll: slidesToShowSm
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: slidesToShowXs,
                slidesToScroll: slidesToShowXs
            }
        }]

    });
};

function slickSlider(value) {
    value.not('.slick-initialized').slick({
        infinite: true,
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
    });
}

function addResizeCarousels(selector, breakpoint, options) {
    if (!selector) return false;

    var $carousels = $(selector),
        breakpoint = breakpoint || 768,
        options = options || null;

    var windW = window.innerWidth || $(window).width();

    if (windW < breakpoint) {
        $carousels.each(function () {
            $(this).not('.slick-initialized').slick(options);
        });
    } else {
        $carousels.each(function () {
            if ($(this).hasClass('slick-initialized'))
                $(this).slick('unslick');
        });
    }
};

var addResizeCarousels_timeout;

$(window).resize(function () {

    clearTimeout(addResizeCarousels_timeout);

    addResizeCarousels_timeout = setTimeout(function () {
        addResizeCarousels(
            '.carousel-products-mobile',
            791, {
                slidesToShow: 2,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 583,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            }
        );

        addResizeCarousels(
            '.carousel-products-mobile-md',
            1025, {
                slidesToShow: 2,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 583,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            }
        );
    }, 100);
});


// Collapse Block (left column in listing)
function expanderList() {
    $('.expander-list .expander').each(function () {
        if ($(this).parent('li').hasClass('active')) {
            $(this).next('ul').slideDown(0);
            $(this).parent().addClass('open');
        }
    })
    $(".expander-list .expander").on('click', function (e) {
        e.preventDefault;
        var speed = 300;
        var thisItem = $(this).parent(),
            nextLevel = $(this).next('ul');
        if (thisItem.hasClass('open')) {
            thisItem.removeClass('open');
            nextLevel.slideUp(speed);
        } else {
            thisItem.addClass('open');
            nextLevel.slideDown(speed);
        }
    })
};

function collapseBlock() {
    if ($("#pageContent .collapse-block").length > 0) {
        var item = $("#pageContent .collapse-block"),
            itemTitle = $("#pageContent .collapse-block_title"),
            itemContent = $('.collapse-block_content');

        item.each(function () {
            if ($(this).hasClass('open')) {
                $(this).find(itemContent).slideDown();
            } else {
                $(this).find(itemContent).slideUp();
            }
        });
        itemTitle.on('click', function (e) {
            e.preventDefault;
            var speed = 300;
            var thisParent = $(this).parent(),
                nextLevel = $(this).next('.collapse-block_content');
            if (thisParent.hasClass('open')) {
                thisParent.removeClass('open');
                nextLevel.slideUp(speed);
            } else {
                thisParent.addClass('open');
                nextLevel.slideDown(speed);
            }
        })
    }
    ;
};

function leftColumnMobile() {
    $('.slide-column-close').trigger('click');
}

function rowViewProductSmall() {
    var currentW = $(".product-listing.row-view .product").width();
    if (currentW < 591) {
        $(".product").addClass("short");
    }
}

// Listing view mode
function listingModeToggle() {
    var filtersRow = $('.filters-row');
    if (filtersRow.length) {
        var linkRowView = filtersRow.find('a.link-row-view'),
            linkGridView = filtersRow.find('a.link-grid-view'),
            linkViewMobile = filtersRow.find('.link-view-mobile'),
            productListing = $('.product-listing');

        linkRowView.on('click', function (e) {
            e.preventDefault();
            $(this).addClass('active');
            linkGridView.removeClass('active');
            linkViewMobile.removeClass('active');
            productListing.addClass('row-view').removeClass('row-view-one').find('.product').removeClass('small small-xs');
            rowViewProductSmall();
        });
        linkGridView.on('click', function (e) {
            e.preventDefault();
            $(this).addClass('active');
            linkRowView.removeClass('active');
            linkViewMobile.removeClass('active');
            productListing.removeClass('row-view').removeClass('row-view-one');
            $(window).trigger('resize');
        });
        linkViewMobile.on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            linkGridView.removeClass('active');
            linkRowView.removeClass('active');
            productListing.removeClass('row-view').toggleClass('row-view-one');
        });
    }
    ;
};

// header view search
function headerViewSearch() {
    $('body').on('click', 'header .search-open', function (e) {
        e.preventDefault();
        $(this).parent('.search').addClass('open');
        $(this).next('#search-dropdown, .search-dropdown').addClass('open');
        $('header .badge').addClass('badge--hidden');

        $('.header-01, .header-02, .header-03').length > 0 && $('.header-menu').addClass('opacity');
        ($('.header-04').length > 0 || $('.header-08').length > 0) && $('.logo, .toggle-menu, .language, .currency, .account, .cart').addClass('opacity');
        $('.header-05').length > 0 && $('.logo, .account, .cart, .header-menu').addClass('opacity');
        $('.header-07').length > 0 && $('.cart').addClass('opacity');
    })
        .on('click', 'header .search-close', function (e) {
            e.preventDefault();
            $(this).closest('.search').removeClass('open');
            $(this).closest('#search-dropdown, .search-dropdown').removeClass('open');
            $('header .badge').removeClass('badge--hidden');

            $('.header-01, .header-02, .header-03').length > 0 && $('.header-menu').removeClass('opacity');
            ($('.header-04').length > 0 || $('.header-08').length > 0) && $('.logo, .toggle-menu, .language, .currency, .account, .cart').removeClass('opacity');
            $('.header-05').length > 0 && $('.logo, .account, .cart, .header-menu').removeClass('opacity');
            $('.header-07').length > 0 && $('.cart').removeClass('opacity');
        });
}

// Slide Column
function slideColumn() {
    if ($('.leftColumn, .slide-column-close').length > 0) {
        $('.slide-column-close').addClass('position-fix');
        $('.slide-column-open').on('click', function (e) {
            e.preventDefault();
            $('.leftColumn, .slide-column-close').addClass('column-open');
            $('body').css("top", -$('body').scrollTop());
            $('body').addClass("no-scroll").append('<div class="modal-filter"></div>');
            if ($(".modal-filter").length > 0) {
                $(".modal-filter").click(function () {
                    $('.slide-column-close').trigger('click');
                })
            }
        });
        $('.slide-column-close').on('click', function (e) {
            e.preventDefault();
            $(".leftColumn, .slide-column-close").removeClass('column-open');
            var top = parseInt($('body').css("top").replace("px", "")) * -1;
            $('body').removeAttr("style");
            $('body').removeClass("no-scroll");
            $('body').scrollTop(top);
            $(".modal-filter").unbind();
            $(".modal-filter").remove();
        });
    }
}

jQuery(function ($) {

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if (params && typeof params['email'] != 'undefined') {
        console.debug('Setting param');
        $('.tf-form').data('tf-hidden', 'email=' + params['email']);
    }

    $('body').on('click', 'form[name="form-fast-checkout"] button[name="checkout"]', function (e) {
        e.preventDefault();
        console.debug('Checkout init');
        var $form = $(this).closest('form');

        if ($form.attr('action') === '/cart') {
            $form.attr('action', BOLD.csp.app.getCheckoutUrl());
        }
        $form[0].submit();
    });

    $('body').on('change', '.rebuy-select', function (e) {
        var val = $(this).val();
        console.debug(val);

        var parent = $(this).closest('.rebuy-product-block');

        // var t = window.applyCSPDiscounts(BOLD.common.Shopify.variants[val])
        // if (t) {
        //     $('.rebuy-product-price .rebuy-money:not(.compare-at)', parent).html(BOLD.common.Shopify.formatMoney(t.price));
        // }
    });

    $('.add-to-cart').on('click', function (e) {
        var handle = $(this).data('handle');
        var $form = $(this).closest('form');
        var id = $('select', $form).first().val();
        var item = {
            Name: '',
            ProductID: '',
            Categories: '',
            ImageURL: '',
            URL: '',
            Brand: '',
            Price: '',
            CompareAtPrice: ''
        };
        if (handle !== '') {
            if (typeof productArrOriginalJson[handle] !== 'undefined') {
                item.Name = productArrOriginalJson[handle].title;
                item.ProductID = productArrOriginalJson[handle].id;
                item.ImageURL = productArrOriginalJson[handle].featured_image;
                item.URL = window.location.href + '/products/' + productArrOriginalJson[handle].handle;
                item.Brand = productArrOriginalJson[handle].vendor;
                item.Price = productArrOriginalJson[handle].price / 100;
                if (productArrOriginalJson[handle].variants && productArrOriginalJson[handle].variants.length > 1) {
                    var fVariants = productArrOriginalJson[handle].variants.filter(function (v, i) {
                        return v.id == id;
                    });
                    var variant = fVariants.length > 0 ? fVariants[0] : null;
                    bcLog(variant);
                    if (variant) {
                        item.Option = variant.options.join(' - ');
                        item.Price = variant.price / 100;
                    }
                }
            }
            if (typeof productArrJson[handle] !== 'undefined') {
                if (productArrJson[handle].variants && productArrJson[handle].variants.length > 1) {
                    var fVariants = productArrJson[handle].variants.filter(function (v, i) {
                        return v.id == id;
                    });
                    var variant = fVariants.length > 0 ? fVariants[0] : null;
                    bcLog(variant);
                    if (variant) {

                        item.Price = variant.price / 100;
                    }
                }
            }
        }
        _learnq.push(['track', 'Added to Cart', item]);
    });

    $('li[data-link]').each(function (index, el) {
        bcLog(el);
        $(el).css('cursor', 'pointer');
        var ww = $(el).data('link');
        $(el).on('click', function () {
            window.location.href = ww;
        });
    });

    function listFilter() {
        var currentW = window.innerWidth || $(window).width();
        var filterRow = $('.filters-row');
        var filterMobile = $('.filters-mobile');

        function insertMobileFilter() {
            var filterMobilePart01 = filterRow.find('div.pull-left .filters-row_select').detach();
            var filterMobilePart02 = filterRow.find('div.pull-right .filters-row_select').detach();
            var filterMobilePart03 = filterRow.find('.link-sort-top');
            $('.filters-mobile').append(filterMobilePart03, filterMobilePart01, filterMobilePart02).find('.filters-row_select').removeClass('hidden-sm hidden-xs');
        };

        function insertFilter() {
            var filterMobilePart01 = filterMobile.find('.filters-row_select').first().detach();
            var filterMobilePart02 = filterMobile.find('.filters-row_select').last().detach();
            var filterMobilePart03 = filterMobile.find('.link-sort-top').detach();
            filterRow.find('div.pull-left').prepend(filterMobilePart01, filterMobilePart03);
            filterRow.find('div.pull-right').prepend(filterMobilePart02);
        };
        if (currentW <= 1024) {
            insertMobileFilter();
        } else if (currentW > 1024) {
            insertFilter();
        } else {
            $('#pageContent .filters-row').addClass('filter-no-sidebar').find(".filters-row_select").removeClass('hidden-sm hidden-xs');
            $('#pageContent .filters-row .slide-column-open').remove();
        }
    };
    $(window).on('ready resize', function () {
        if ($("#pageContent .filters-row").length && $('#pageContent .leftColumn').length) {
            listFilter();
        }
        ;
    });
});

function listDetachRightCol() {
    var leftColContent = $("#pageContent .leftColumn .detach-rightCol"),
        rightColContent = $("#pageContent .rightColumn .detach-rightCol"),
        rightCol = $("#pageContent .rightColumn"),
        lefttCol = $("#pageContent .leftColumn");
    if (leftColContent.length && rightCol.css('display') == 'block') {
        var rightColumnContent = leftColContent.detach();
        rightCol.prepend(rightColumnContent);
    } else if (rightColContent.length && rightCol.css('display') == 'none') {
        var leftColumnContent = rightColContent.detach();
        lefttCol.append(leftColumnContent);
    }
};
$(window).on('ready resize', function () {
    if ($("#pageContent .rightColumn").length) {
        listDetachRightCol();
    }
});

function cartTableDetach() {
    var desctopQuantity = $(".shopping-cart-table .detach-quantity-desctope"),
        mobileQuantity = $(".shopping-cart-table .detach-quantity-mobile");
    if (desctopQuantity.length && mobileQuantity.parent().css('display') == 'block') {
        desctopQuantity.each(function () {
            var quantityObj = $(this).find('.input').detach().get(0);
            $(this).parent().parent().find('.detach-quantity-mobile').prepend(quantityObj);
        })
    } else if (mobileQuantity.length && mobileQuantity.parent().css('display') == 'none') {
        mobileQuantity.each(function () {
            var quantityObj = $(this).find('.input').detach().get(0);
            $(this).closest("tr").find('.detach-quantity-desctope').prepend(quantityObj);
        });
    }
    ;
};
$(window).on('ready resize', function () {
    if ($(".shopping-cart-table").length) {
        cartTableDetach();
    }
});


// input-counter
function inputCounter() {
    if ($(".input-counter").length > 0) {
        $('.minus-btn, .plus-btn').click(function (e) {
            var $input = $(this).parent().find('input');
            var count = parseInt($input.val()) + parseInt(e.currentTarget.className == 'plus-btn' ? 1 : -1);
            $input.val(count).change();
        });
        $(".input-counter input").change(function () {
            var _ = $(this);
            var min = 1;
            var val = parseInt(_.val());
            var max = parseInt(_.attr('size'));
            val = Math.min(val, max);
            val = Math.max(val, min);
            _.val(val);
        })
            .on("keypress", function (e) {
                if (e.keyCode == 13) {
                    e.preventDefault();
                }
            });
    }
}

// Mobile footer collapse
function footerCollapse() {
    $('body').on('click', '.mobile-collapse_title', function (e) {
        e.preventDefault;
        $(this).parent('.mobile-collapse').toggleClass('open');
    })
};

// backToTop
function backToTop() {
    var $obj = $(".back-to-top");
    if ($obj.length > 0) {
        $obj.click(function () {
            $('html, body').animate({
                scrollTop: 0
            }, 500);
            return false;
        })

        $(window).scroll(function () {
            if ($(window).scrollTop() > 500) {
                $obj.stop(true.false).fadeIn(110)
            } else {
                $obj.stop(true.false).fadeOut(110)
            }
        })
    }
}

//=========== header menu(hover)
(function toggle_header_menu() {
    var delay = header_menu_timeout,
        hoverTimer = header_menu_delay,
        timeout1 = false;

    var set_dropdown_maxH = function () {
        var wind_H = window.innerHeight,
            $menu = $(this).find('.dropdown-menu'),
            menu_top = $menu.get(0).getBoundingClientRect().top,
            menu_max_H = wind_H - menu_top,
            $menu_H = $menu.innerHeight(),
            $btn_top = $('.back-to-top');

        if ($menu_H > menu_max_H) {
            var $body = $('body'),
                $stuck = $('.stuck-nav');
            $menu.css({
                maxHeight: menu_max_H - 20,
                overflow: 'auto'
            });

            var scrollWidth = function () {
                var $div = $('<div>').css({
                    overflowY: 'scroll',
                    width: '50px',
                    height: '50px',
                    visibility: 'hidden'
                });

                $body.append($div);
                var scrollWidth = $div.get(0).offsetWidth - $div.get(0).clientWidth;
                $div.remove();

                return scrollWidth;
            };

            $body.css({
                overflowY: 'hidden',
                paddingRight: scrollWidth()
            });

            $stuck.css({
                paddingRight: scrollWidth()
            });

            $btn_top.css({
                right: scrollWidth()
            });
        }
    };

    if ($('.header-menu, .menu-vertical nav').length > 0) {
        $(document).on({
            mouseenter: function () {
                var $this = $(this),
                    that = this;

                timeout1 = setTimeout(function () {

                    var $carousel = $this.find('.carousel-menu-1.header-menu-product'),
                        $menu = $this.find('.dropdown-menu');


                    $this.addClass('active')
                        .find(".dropdown-menu")
                        .stop()
                        .addClass('hover')
                        .fadeIn(hoverTimer);

                    if ($menu.length & !$menu.hasClass('one-col')) {
                        set_dropdown_maxH.call(that);
                    }

                    if ($carousel.length) {
                        if (!$carousel.hasClass('slick-initialized')) {
                            setSlickGallery($carousel, 2, 2, 2, 2, 2, 'carousel');
                        } else {
                            $carousel.slick('setPosition');
                        }
                        var obgCarusel = $('.header-menu .header-menu-product');
                        if (obgCarusel.length) {
                            var widthCarusel = obgCarusel.parent().width();
                            var widthCarusel = widthCarusel - 8;
                            obgCarusel.css({
                                width: widthCarusel
                            });
                        }
                    }

                }, delay);
            },
            mouseleave: function (e) {
                var $this = $(this),
                    $dropdown = $this.find(".dropdown-menu");

                if ($(e.target).parents('.dropdown-menu').length && !$(e.target).parents('.megamenu-submenu').length && !$(e.target).parents('.one-col').length) return;

                if (timeout1 !== false) {
                    clearTimeout(timeout1);
                    timeout1 = false;
                }

                if ($dropdown.length) {
                    $dropdown.stop().fadeOut({
                        duration: 0, complete: function () {
                            $this.removeClass('active')
                                .find(".dropdown-menu")
                                .removeClass('hover');
                        }
                    });
                } else {
                    $this.removeClass('active')
                        .find(".dropdown-menu")
                        .removeClass('hover');
                }

                $dropdown.removeAttr('style');

                $('body').removeAttr('style');

                $('.stuck-nav').css({
                    paddingRight: 'inherit'
                });

                $('.back-to-top').css({
                    right: 0
                });
            }
        }, '.header-menu li, .menu-vertical nav li');

        $('.multicolumn ul li').hover(function () {
            var $ul = $(this).find('ul:first');

            if ($ul.length) {
                var windW = window.innerWidth,
                    windH = window.innerHeight,
                    ulW = parseInt($ul.css('width')),
                    thisR = this.getBoundingClientRect().right,
                    thisL = this.getBoundingClientRect().left;

                if (windW - thisR < ulW) {
                    $ul.removeClass('left').addClass('right');
                } else if (thisL < ulW) {
                    $ul.removeClass('right').addClass('left');
                } else {
                    $ul.removeClass('left right');
                }
                $ul.stop(true, true).fadeIn(300);

            }
        }, function () {
            $(this).find('ul:first').stop(true, true).fadeOut(300).removeAttr('style');
        });

        $('.megamenu-submenu li').hover(function () {
            var $ul = $(this).find('ul:first');

            if ($ul.length) {
                var $dropdownMenu = $(this).parents('.dropdown').find('.dropdown-menu'),
                    dropdown_left = $dropdownMenu.get(0).getBoundingClientRect().left,
                    dropdown_Right = $dropdownMenu.get(0).getBoundingClientRect().right,
                    dropdown_Bottom = $dropdownMenu.get(0).getBoundingClientRect().bottom,
                    ulW = parseInt($ul.css('width')),
                    thisR = this.getBoundingClientRect().right,
                    thisL = this.getBoundingClientRect().left;

                if (dropdown_Right - 20 - thisR < ulW) {
                    $ul.removeClass('left').addClass('right');
                } else if (thisL - ulW - 20 < dropdown_left) {
                    $ul.removeClass('right').addClass('left');
                } else {
                    $ul.removeClass('left right');
                }

                $ul.stop(true, true).fadeIn(300);

                var ul_bottom = $ul.get(0).getBoundingClientRect().bottom;

                if (dropdown_Bottom < ul_bottom) {
                    var move_top = dropdown_Bottom - ul_bottom;
                    $ul.css({
                        top: move_top
                    });
                }
            }
        }, function () {
            $(this).find('ul:first').stop(true, true).fadeOut(300).removeAttr('style');
        });

        $('.megamenu div').hover(function () {
            $(this).children('.title-underline').addClass('active');
        }, function () {
            $(this).children('.title-underline').removeClass('active');
        });

    }
    if ($('.menu-vertical nav').length > 0) {
        $('.menu-vertical nav li:not(.multicolumn)').hover(function () {
            var $this = $(this);
            var menuVerticalHeight = $('.menu-vertical').innerHeight();
            var menuVerticalPopupHeight = $(this).find('.dropdown-menu').innerHeight();
            if (menuVerticalHeight >= menuVerticalPopupHeight) {
                $(this).find('.dropdown-menu').css({
                    'minHeight': menuVerticalHeight
                });
            }
            ;
        }, function () {
            $(this).find('.dropdown-menu').removeAttr('style');
        });
    }

    function onscroll_dropdown_hover() {
        var $dropdown_active = $('.dropdown.hover');

        if (!$dropdown_active.find('.dropdown-menu').not('.one-col').length) return;

        if ($dropdown_active.length)
            set_dropdown_maxH.call($dropdown_active);
    };
    $(window).on('scroll', function () {
        onscroll_dropdown_hover();
    });
})();

// Search DropDown
function searchDropDown() {
    var searchOpen = $('header .search-open'),
        searchClose = $('header .search-close'),
        searchBadge = $('header .badge');
    if (searchOpen.length) {
        searchOpen.on('click', function (e) {
            e.preventDefault();
            $(this).parent('.search').addClass('open');
            $(this).next('#search-dropdown, .search-dropdown').addClass('open');
            searchBadge.addClass('badge--hidden');
        });
        searchClose.on('click', function (e) {
            e.preventDefault();
            $(this).closest('.search').removeClass('open');
            $(this).closest('#search-dropdown, .search-dropdown').removeClass('open');
            searchBadge.removeClass('badge--hidden');
        });
    }
    ;
};

// Cart
function cartSlideIni() {
    if ($("header .cart").length > 0) {
        $('body').on('click', 'header .cart .dropdown-toggle', function (e) {
            headerCartSize();
            setTimeout(function () {
                $(".cart .dropdown").toggleClass('open');
            }, 0);
            e.preventDefault();
        })
            .on('click', 'header .cart .cart-close', function (e) {
                $(".cart .dropdown").toggleClass('open');
                $('body').removeClass('cart-open');
                e.preventDefault();
            });
        $(window).resize(function () {
            $(".cart .dropdown").hasClass('open') && headerCartSize();
        });
    }
}

function headerCartSize() {
    $("header .cart").find(".dropdown-menu").scrollTop(0);
    cartHeight();
}

function cartHeight() {
    var $obj = $("header .cart").find(".dropdown-menu");

    $obj.removeAttr('style');

    setTimeout(function () {
        var w_height = $(window).height();
        var o_height = $obj.height();
        var delta = parseInt(w_height - o_height);

        if (delta < 0) {
            $obj.css({
                "max-height": o_height + delta,
                "overflow": "auto",
                "overflow-x": "hidden"
            });
            $('body').addClass('cart-open');
        } else {
            $('body').removeClass('cart-open');
        }
    }, 10);
}

//radio Click
function radioClickList() {
    if ($(".radio-list").length > 0) {
        $('.radio-list li').on('click', function () {
            $(".radio-list li").removeClass("active");
            $(this).addClass("active");
        });

    }
}

// tooltip
$(function () {
    $("[data-toggle=popover]").popover();

})

//calendar
function calendarDatepicker() {
    if ($(".calendarDatepicker").length > 0) {
        $('.calendarDatepicker').datepicker();

    }
}

// Vertical carousel
function verticalCarousel() {
    var verticalCarousel = $(".vertical-carousel");
    if (verticalCarousel.length == 0) return false;

    verticalCarousel.slick({
        infinite: false,
        dots: false,
        vertical: true,
        slidesToShow: 2,
        slidesToScroll: 1,
    });

    $(window).on('resize', function () {
        verticalCarousel.slick('setPosition').slick('setPosition');
    });
}


function gridGalleryMasonr() {

    $(window).on('load', function () {

        if ($(".gallery-masonry").length > 0) {
            // init Isotope
            var $grid = $('.grid-gallery-masonry').isotope({
                itemSelector: '.element-item',
                layoutMode: 'masonry',
                masonry: {
                    gutter: 0
                }
            });
            // filter functions
            var filterFns = {
                ium: function () {
                    var name = $(this).find('.name').text();
                    return name.match(/ium$/);
                }
            };
            // bind filter button click
            $('.gallery-masonry .filter-nav').on('click', '.button', function () {
                var filterValue = $(this).attr('data-filter');
                // use filterFn if matches value
                filterValue = filterFns[filterValue] || filterValue;
                $grid.isotope({
                    filter: filterValue
                });
            });
            // change is-checked class on buttons
            $('.gallery-masonry .filter-nav .button').each(function (i, buttonGroup) {
                var $buttonGroup = $(buttonGroup);
                $buttonGroup.on('click', '.button', function () {
                    $buttonGroup.find('.is-checked').removeClass('is-checked');
                    $(this).addClass('is-checked');
                });
            });
        }
    })
}

var elevateZoomWidget = {
    scroll_zoom: true,
    class_name: '.zoom-product',
    thumb_parent: $('#smallGallery'),
    scrollslider_parent: $('.slider-scroll-product'),
    checkNoZoom: function () {
        return $(this.class_name).parent().parent().hasClass('no-zoom');
    },
    init: function (type) {
        var _ = this;
        var currentW = window.innerWidth || $(window).width();
        var zoom_image = $(_.class_name);
        var _thumbs = _.thumb_parent;
        _.initBigGalleryButtons();
        _.scrollSlider();
        if (_thumbs.length > 0) {


            $('.product-main-image').prepend('<button class="btn-main-image btn-prev"></button>');
            $('.product-main-image').append('<button class="btn-main-image btn-next"></button>');
            $('body').on('click', '.btn-main-image.btn-prev', function (e) {
                e.preventDefault();
                // $(_thumbs).slick('slickPrev');
                var numSlides = document.querySelectorAll('#smallGallery .slick-slide').length;
                var currentSlide = parseInt(document.querySelector('#smallGallery .slick-current').getAttribute('data-slick-index'));


                currentSlide = (currentSlide - 1) > 0 ? currentSlide - 1 : 0;
                console.log('currentSlide: ', currentSlide, numSlides);
                // $(_thumbs).slick('goTo', currentSlide);
                $('#smallGallery .slick-slide').removeClass('slick-current');
                $($('#smallGallery .slick-slide')[currentSlide]).addClass('slick-current');
                $($('#smallGallery .slick-slide a')[currentSlide]).trigger('click');
                setTimeout(function () {
                    $('#smallGallery .slick-current a').trigger('click');
                }, 300)
            })
            $('body').on('click', '.btn-main-image.btn-next', function (e) {
                e.preventDefault();
                // $(_thumbs).slick('slickNext');
                var numSlides = document.querySelectorAll('#smallGallery .slick-slide').length;
                var currentSlide = parseInt(document.querySelector('#smallGallery .slick-current').getAttribute('data-slick-index'));


                currentSlide = (currentSlide + 1) < numSlides ? currentSlide + 1 : numSlides;
                console.log('currentSlide: ', currentSlide, numSlides);
                // $(_thumbs).slick('goTo', currentSlide);
                $('#smallGallery .slick-slide').removeClass('slick-current');
                $($('#smallGallery .slick-slide')[currentSlide]).addClass('slick-current');
                $($('#smallGallery .slick-slide a')[currentSlide]).trigger('click');

                setTimeout(function () {
                    $('#smallGallery .slick-current a').trigger('click');
                }, 300)

            })
        }

        if (zoom_image.length == 0) return false;
        if (!_.checkNoZoom()) {
            var attr_scroll = zoom_image.parent().parent().attr('data-scrollzoom');
            attr_scroll = attr_scroll ? attr_scroll : _.scroll_zoom;
            _.scroll_zoom = attr_scroll == 'false' ? false : true;
            currentW > 767 && _.configureZoomImage();
            _.resize();
        }

        if (_thumbs.length == 0) return false;
        var thumb_type = _thumbs.parent().attr('class').indexOf('-vertical') > -1 ? 'vertical' : 'horizontal';
        _[thumb_type](_thumbs);
        updateSlider();
        if ($('#smallGallery .slick-current').index() === 0) {
            $('.btn-main-image.btn-prev').hide();
        } else {
            $('.btn-main-image.btn-prev').show();
        }

        function updateSlider() {
            _.setBigImage(_thumbs);
        }
    },
    configureZoomImage: function () {
        var _ = this;
        $('.zoomContainer').remove();
        var zoom_image = $(this.class_name);
        zoom_image.each(function () {
            var _this = $(this);
            var clone = _this.removeData('elevateZoom').clone();
            _this.after(clone).remove();
        });
        setTimeout(function () {
            if (window.innerWidth >= 768) {
                $(_.class_name).elevateZoom({
                    gallery: _.thumb_parent.attr('id'),
                    zoomType: "inner",
                    scrollZoom: Boolean(_.scroll_zoom),
                    cursor: "crosshair",
                    zoomWindowFadeIn: 300,
                    zoomWindowFadeOut: 300
                });
            }
        }, 100);
    },
    resize: function () {
        var _ = this;
        $(window).resize(function () {
            var currentW = window.innerWidth || $(window).width();
            if (currentW <= 767) return false;
            _.configureZoomImage();
        });
    },
    horizontal: function (_parent) {
        _parent.slick({
            infinite: false,
            dots: false,
            arrows: true,
            slidesToShow: 7,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        infinite: false,
                        slidesToShow: 10,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        infinite: false,
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                }]
        });
    },
    vertical: function (_parent) {
        _parent.slick({
            vertical: true,
            infinite: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            verticalSwiping: true,
            arrows: true,
            dots: false,
            centerPadding: "6px",
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    },
    initBigGalleryButtons: function () {
        var bigGallery = $('.bigGallery');
        if (bigGallery.length == 0) return false;
        $('body')
            .on('mouseenter', '.zoomContainer', function () {
                bigGallery.find('button').addClass('show');
            })
            .on('mouseleave', '.zoomContainer', function () {
                bigGallery.find('button').removeClass('show');
            });
    },
    scrollSlider: function () {
        var _scrollslider_parent = this.scrollslider_parent;
        if (_scrollslider_parent.length == 0) return false;
        _scrollslider_parent.on('init', function (event, slick) {
            _scrollslider_parent.css({'opacity': 1});
        });
        _scrollslider_parent.css({'opacity': 0}).slick({
            infinite: false,
            vertical: true,
            verticalScrolling: true,
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
        }).mousewheel(function (e) {
            e.preventDefault();
            e.deltaY < 0 ? $(this).slick('slickNext') : $(this).slick('slickPrev');
        });
    },
    setBigImage: function (_parent) {
        var _ = this;
        _parent.find('a').on('click touchstart', function (e) {
            //console.log('clicked', e.target);

            //_.checkNoZoom() &&
            e.preventDefault();
            var zoom_image = $(_.class_name);
            var getParam = !_.checkNoZoom() ? 'data-image' : 'data-zoom-image';
            var setParam = !_.checkNoZoom() ? 'src' : 'src';
            var big_image = $(this).attr(getParam);
            var parent = $(this).closest('.slick-slide');
            $('#smallGallery .slick-slide').removeClass('slick-current');
            parent.addClass('slick-current');
            //console.log('getParam', getParam);
            //console.log('setParam', setParam);
            zoom_image.attr(setParam, big_image);

            //if (!_.checkNoZoom()) return false;
            _parent.find('.zoomGalleryActive').removeClass('zoomGalleryActive');
            $(this).addClass('zoomGalleryActive');

            if ($('#smallGallery .slick-current').index() ===
                $('#smallGallery .slick-slide').length - 1) {
                $('.btn-main-image.btn-next').hide();
            } else {
                $('.btn-main-image.btn-next').show();
            }
            if ($('#smallGallery .slick-current').index() === 0) {
                $('.btn-main-image.btn-prev').hide();
            } else {
                $('.btn-main-image.btn-prev').show();
            }
        });
    }
}
elevateZoomWidget.init();

function videoPost() {
    if ($(".video-block").length > 0) {
        $('.link-video').click(function (e) {
            e.preventDefault();
            var myVideo = $(this).parent().find('.movie')[0];
            if (myVideo.paused) {
                myVideo.play();
                $(this).addClass('play');
            } else {
                myVideo.pause();
                $(this).removeClass('play');
            }
        });
    }
}

function videoPopup() {
    $('#modalVideoProduct').on('show.bs.modal', function (e) {
        var relatedTarget = $(e.relatedTarget),
            attr = relatedTarget.attr('data-value'),
            attrType = relatedTarget.attr('data-type');

        if (attrType == "youtube" || attrType == "vimeo" || attrType == undefined) {
            $('<iframe src="' + attr + '" allowfullscreen></iframe>').appendTo($(this).find('.modal-video-content'));
        }
        ;
        if (attrType == "video") {
            $('<div class="video-block"><a href="#" class="link-video"></a><video class="movie"  src="' + attr + '" allowfullscreen></video></div>').appendTo($(this).find('.modal-video-content'));
            videoPost();
        }
        ;
    }).on('hidden.bs.modal', function () {
        $(this).find('.modal-video-content').empty();
    });
}

function initializeSelect(that) {

    bcLog('initializeSelect');
    bcLog(that);

    jQuery(that).change(function () {
        var inventory = jQuery('option:selected', that).data('inventory');
        const parent = $(this).attr('.form__product');
        let options = '';
        for (let i = 1; i <= Math.min(inventory, 20); i++) {
            options += `<option value="${i}">${i}</option>`;
        }
        if (options === '') {
            $('.klaviyo-bis-trigger').addClass('btn').removeClass('hidden');
        } else {
            $('select[name="quantity"]', parent).html(options);
        }
        console.debug('change')
        checkVariantSelected(this);
    });

    jQuery(that).addClass('initialized-select');

    var id = jQuery("option:selected", jQuery(that)).data('id');
    console.debug("id: ", id);
    var handle = jQuery(that).data('handle');
    if (!id) {
        return;
    } else {
        if (id != '')
            jQuery('input[name="id"]').val(id);
        var price = jQuery('option:selected', that).data('price');
    }
    var parentProduct = jQuery(that).closest('.product-wrapper');
    var parent = jQuery(that).closest('.product-wrapper');
    var qtyInput = jQuery('[name="quantity"]', parent);
    var qty = qtyInput.val();
    if (typeof handle === "undefined") {
        handle = jQuery('.product-info-1').data('handle');
    }

    var variant = productArrJson[handle].variants.filter(function (e) {
        return e.id == id || e.title == id
    });
    if (variant && variant.length > 0) {
        price = '$' + (variant[0].price / 100).toFixed(2);
    }

    bcLog(handle);

    var showCoin = false;
    var variantToPrice = [];
    jQuery('option', that).each(function (index, el) {
        var variantId = null;
        if ($(el).attr('value')) {
            variantId = $(el).attr('value');
        }
        //bcLog('dd '+$(el).data('id'));
        if ($(el).data('id')) {
            variantId = $(el).data('id');
        }

        if (variantId) {
            var variant1 = productArrOriginalJson[handle].variants.filter(function (e) {
                return e.id == variantId
            });
            if (variant1 && variant1.length > 0) {
                variantToPrice['' + variantId] = '$' + (variant1[0].price / 100).toFixed(2);
            }
        }
    });

    bcLog('variantToPrice: ', variantToPrice);

    $(productArrJson[handle].variants).each(function (index, el) {

        var newPrice = '$' + (el.price / 100).toFixed(2);
        bcLog('Price for: ' + el.id);
        bcLog('Old Price: ' + variantToPrice[el.id]);
        bcLog('New Price: ' + newPrice);
        if ((typeof newPrice != "undefined"
            && typeof variantToPrice[el.id] != "undefined"
            && variantToPrice[el.id] !== newPrice)) {
            //var opt = $('option[value="'+el.id+'"]').html();
            //$('option[value="'+el.id+'"]').html(opt);
            $('option[value="' + el.id + '"]').data('coin', coinClass);
            $('option[value="' + el.id + '"]').data('coin-text', coinText);
            $('option[data-id="' + el.id + '"]').data('coin', coinClass);
            $('option[data-id="' + el.id + '"]').data('coin-text', coinText);
            showCoin = true;
        }
    });

    bcLog('showCoin: ' + showCoin);
    bcLog(parentProduct);

    if (jQuery('option', that).length === 0) {
        showCoin = false;
    }

    if (showCoin === true) {
        $('.icon-coin', parentProduct).removeClass('hidden');
    } else {
        $('.icon-coin', parentProduct).addClass('hidden');
    }

    var compare_at_price_elem = jQuery('option:selected', this).data('compare_at_price');
    var compare_at_price = compare_at_price_elem ? compare_at_price_elem.replace('$', '').trim() : '';

    var compare_price_str = '';
    if (compare_at_price !== '') {
        compare_price_str = '<span class="discount_price">$' + compare_at_price + '</span>';
    }


    if (price && typeof price !== "undefined") {
        bcLog('price xx: ' + price);
        jQuery('input[name="id"]').data('price', price);
        var price1 = price.replace('$', '').replace(',', '').trim();
        var btnText = 'ADD';
        if (jQuery(that).parent().find('.add-to-cart').text().indexOf('Add to Cart') !== -1) {
            btnText = 'Add to Cart - ';
        }
        jQuery(that).parent().find('.add-to-cart').html(btnText + ' <span class="price">$' + (price1 * qty).toFixed(2) + '</span>' + compare_price_str).prop("disabled", false);

        $('.add-to-cart .discount_price', parent).text('');
        if (compare_price_str !== '') {
            if ($('.add-to-cart .discount_price', parent).length > 0) {
                $('.add-to-cart .discount_price', parent).text('$' + compare_at_price);
            } else {
                $('.add-to-cart .price', parent).after(compare_price_str);
            }
        } else {
            $('.add-to-cart .discount_price', parent).remove();
        }

    } else {
        bcLog('price xx: null');
        jQuery('input[name="id"]').data('price', null);
        jQuery(that).parent().find('.add-to-cart').text('ADD').prop("disabled", "disabled");
    }


}

function checkVariantSelected(that1) {
    var parent = jQuery(that1).closest('form');
    bcLog("Testing elem: ", that1);

    var selectedOption = jQuery(jQuery('select:not([name="quantity"]) option:selected', parent).last()[0]);

    var id = selectedOption.data('id');
    var handle = jQuery(that1).data('handle');
    console.log('selected:', id, handle);
    if (!id) {
        id = jQuery('[data-handle="' + handle + '"]', parent).val();
        if (id)
            jQuery('[name="id"]', parent).val(id);

    }

    if (!id) {
        id = jQuery('[name="id"]', parent).val();
    }

    var parentProduct = jQuery(that1).closest('.product-wrapper');

    bcLog("Testing: " + id);
    var reg = /^\d+$/;
    if (id && reg.test(id) && ("" + id).length > 7) {
        jQuery('input[name="id"]', parentProduct).val(id);
    } else {
        id = jQuery('input[name="id"]', parentProduct).val();
    }


    var price = selectedOption.data('price');
    if (price) {
        price = price.replace(',', '');
    } else {
        var priceElem = jQuery('input[name="id"]', parentProduct).data('price');
        if (priceElem) {
            price = priceElem.replace('$', '');
        }
    }
    var oldPrice = selectedOption.data('price1');
    bcLog('oldPrice = ' + oldPrice);
    if (typeof oldPrice === 'undefined') {
        oldPrice = jQuery('.product-info [itemprop="offers"] .price').attr("content");
    }
    var inventory = selectedOption.data('inventory');
    bcLog('inventory = ' + inventory);
    var curQty = $('[name="quantity"]', parent).val();

    if (typeof inventory === 'undefined') {
        inventory = 20;
        var inventoryElem = jQuery('input[name="id"]', parentProduct).data('inventory');
        if (inventoryElem) {
            inventory = inventoryElem;
            bcLog('inventoryElem = ' + inventory);
        }
    }

    let options = '';
    for (let i = 1; i <= Math.min(inventory, 20); i++) {
        options += `<option value="${i}">${i}</option>`;
    }
    $('select[name="quantity"]', parent).html(options);
    $('select[name="quantity"]', parent).val(curQty)

    /*$('[name="quantity"]', parent).attr('size', inventory);
    $('[name="quantity"]', parent).attr('max', inventory);*/
    if (curQty > inventory) {
        $('[name="quantity"]', parent).val(inventory)
    }
    bcLog(`curQty = ${curQty} inventory = ${inventory}`);

    if (inventory == 0) {
        $('.klaviyo-bis-trigger.btn-sm.btn').addClass('visible');
    } else {
        $('.klaviyo-bis-trigger.btn-sm.btn').removeClass('visible');
    }

    // bcLog('OldPrice step 1:' + oldPrice);
    if (typeof oldPrice !== "undefined" && oldPrice !== "undefined" && oldPrice !== null) {
        oldPrice = oldPrice.toString().replace(',', '');
    }

    bcLog("Before In check: " + oldPrice);

    if (typeof productOriginalJson != "undefined") {
        // bcLog('ID validation: ' + id);
        var variantsOld = productOriginalJson.variants.filter(function (el) {

            return el.id == id || el.title.indexOf(id) === 0
        });
        bcLog("In check: " + id);
        bcLog(variantsOld);
        if (variantsOld.length > 0) {
            oldPrice = '$' + variantsOld[0].price / 100;
        }
    }

    // bcLog('OldPrice step 2:' + oldPrice);
    if (typeof handle === "undefined") {
        handle = jQuery('.product-info-1').data('handle');
    }


    var variant = productArrJson[handle].variants.filter(function (e) {
        return e.id == id || e.title.indexOf(id) === 0
    });
    // bcLog(variant);
    if (variant && variant.length === 1) {
        price = (variant[0].price / 100).toFixed(2);
        var compare_at_price_1 = (variant[0].compare_at_price / 100).toFixed(2);
    }

    // bcLog(handle);
    bcLog("ID: ", id, price);
    bcLog(id);
    bcLog(price);
    if (id === null) {
        return;
    }
    if (price == null) {
        return;
    }
    price = (price.toString().replace(',', '').replace('$', '') * 1).toFixed(2);
    console.debug('old-price', oldPrice);
    if (oldPrice == null || oldPrice.replace('$', '') == price) {
        if (compare_at_price_1) {
            oldPrice = compare_at_price_1;
        } else {
            oldPrice = null;
        }
    }
    if (oldPrice != null) {
        oldPrice = (oldPrice.toString().replace('$', '') * 1).toFixed(2);
    }


    bcLog("New price: " + price);
    bcLog("Old price: " + oldPrice);
    if (oldPrice == price || oldPrice === undefined || price === undefined) {
        $('.icon-coin', parentProduct).addClass('hidden');
        $('.price-bc', parentProduct).removeClass('strike');
        $('.price-bc .old-price', parentProduct).show();
        $('.price-bc-box', parentProduct).hide();
    } else {
        $('.icon-coin', parentProduct).removeClass('hidden');
        $('.price-bc.price > span', parentProduct).html('$' + oldPrice);
        $('.price-bc', parentProduct).removeClass('strike');
        $('.price-bc .old-price', parentProduct).hide();
        $('.price-bc-box .old-price', parentProduct).hide();
        $('.price-bc-box', parentProduct).show();
    }

    var compare_at_price_elem = selectedOption.data('compare_at_price');
    var compare_at_price = compare_at_price_elem ? compare_at_price_elem.replace('$', '').trim() : '';
    if (compare_at_price == '' && oldPrice) {
        compare_at_price = oldPrice;
    }

    var compare_price_str = '';
    if (compare_at_price !== '' && compare_at_price != price) {
        compare_price_str = '<span class="discount_price">$' + compare_at_price + '</span>';
    }


    console.debug('price1', price)
    if (price && typeof price !== "undefined") {
        jQuery('input[name="id"]', parent).data('price', price);
        var price1 = price.replace('$', '').trim();
        var btnText = 'ADD';
        if (jQuery(that1).closest('form').find('.add-to-cart').text().indexOf('Add to Cart') !== -1) {
            btnText = 'Add to Cart - ';
        }
        jQuery(that1).closest('form').find('.add-to-cart').html(btnText + ' <span class="price">$' + (price1 * curQty).toFixed(2) + '</span>' + compare_price_str).prop("disabled", false);

        var label = $('.product-info .select2-selection__rendered').text();
        if (document.querySelector('.product-info .price.price-bc')) {
            document.querySelector('.product-info .price.price-bc').setAttribute('data-label', 'Size/Style: ' + label + ' - ');
        }

        const priceTotal = (price1 * curQty);
        if (priceTotal && priceTotal != NaN) {
            let btn_text = 'Add to Cart - ' + '$' + priceTotal.toFixed(2);
            console.debug('compare_price_str:', compare_price_str);
            if (compare_price_str !== '') {
                btn_text += compare_price_str;
            }
            $('.product-info .btn-sm.btn-addtocart').html(btn_text);
        } else {
            $('.product-info .btn-sm.btn-addtocart').html('Add to Cart');
        }

        $('.add-to-cart .discount_price', parent).text('');
        if (compare_price_str !== '') {
            if ($('.add-to-cart .discount_price', parent).length > 0) {
                $('.add-to-cart .discount_price', parent).text('$' + compare_at_price);
            } else {
                $('.add-to-cart .price', parent).after(compare_price_str);
            }
        } else {
            $('.add-to-cart .discount_price', parent).remove();
        }

    } else {
        jQuery('input[name="id"]').data('price', null);
        jQuery(that1).closest('form').find('.add-to-cart').text('ADD').prop("disabled", "disabled");
        $('.add-to-cart .discount_price', parent).remove();
    }


}

function formatBCOption(state) {
    bcLog('Option is:');
    bcLog(state);
    if (state.element) {
        var parent = $(state.element).closest('.select-inline-wrapper');
        bcLog(parent);
        var handle = $('select', parent).data('handle');
        bcLog('handle: ' + handle);

        var priceStr = '';
        if ($(state.element).data('price1')) {
            var price1 = $(state.element).data('price1') + "";
            bcLog('price1 = ' + price1);
            if (typeof price1 !== "undefined" && typeof price1 !== "number" && price1 !== "null" && price1 != null && price1 !== "undefined") {
                priceStr = ' - $' + price1.replace('$', '');
            }
        }
        var val = $(state.element).attr('value');
        var filtered = productArrJson[handle].variants.filter((v) => v.id == val);
        if (filtered.length > 0) {
            var price1 = filtered[0].price / 100 + "";
            priceStr = ' - $' + price1.replace('$', '');
        }

        var avaibilityStr = '';
        if ($(state.element).data('avaibility')) {
            avaibilityStr += $(state.element).data('avaibility');
        }

        var inventoryStr = '';
        if ($(state.element).data('inventory')) {
            inventoryStr += $(state.element).data('inventory');
        }

        if (!$(state.element).data('coin')) {
            return state.text + avaibilityStr + priceStr;
        }
        var coin = $(state.element).data('coin');
        var stateText = $(state.element).data('coin-text');
        var $state = $(
            '<span>' + state.text + priceStr + ' <span class="icon-coin ' + coin + '" data-toggle="tooltip" data-placement="top" title="' + stateText + '"></span>' + '</span>'
        );
        return $state;
    }
    return state;
}

function moveSectProductDetails() {
    $('.product-info-1').after($('.sect__product__details'));
}

jQuery(document).ready(function ($) {

    "use strict";

    moveSectProductDetails();

    buildCollectionFilters();

    $('.icn-cart').on('click', function (e) {
        e.preventDefault();
        const SmartCart = window.Rebuy.SmartCart;
        SmartCart.show(e);
    });

    $(document).mouseup(function (e) {
        var container = $(".filters__type");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.removeClass('selected');
            $('#filter__product_type').removeAttr('checked');
        }
    });

    $('.form__product select').on('invalid', function () {
        this.setCustomValidity('Please select a size before adding to your cart.')
    });

    $('.form__product select').on('change', function () {
        if ($(this).val() !== '') {
            console.log('setCustomValidity() reset');
            this.setCustomValidity('');
        }
    });

    const slugify = str =>
        str
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/[\s_-]+/g, '-')
            .replace(/^-+|-+$/g, '');

    function readingTime() {
        const text = document.getElementsByClassName("post")[0].innerText;
        const wpm = 225;
        const words = text.trim().split(/\s+/).length;
        const time = Math.ceil(words / wpm);
        let minutes = ' minute';
        if (time > 1) {
            minutes = ' minute';
        }
        document.getElementById("time").innerText = time + minutes;
    }

    function buildOverview() {
        const innerLinksWrapper = $('<div class="inner-links-wrapper"><p class="npa-short">Shortcuts</p></div>');
        const innerLinksEl = $('<ul class="inner-links"></ul>');
        let innerLinks = [];
        $('.blog-single-post h2').each(function (i, el) {
            const title = $(el).text().replace(/^[0-9]+\./, '').trim();
            const slug = slugify(title);
            $(el).attr('id', slug);
            innerLinks.push({'id': slug, 'title': title});
            innerLinksEl.append('<li><a href="#' + slug + '">' + title + '</a></li>');
        });

        innerLinksWrapper.append(innerLinksEl);
        $('#summary').append(innerLinksWrapper);
    }

    if ($('.blog-single-post').length > 0 && $('#time').length > 0) {
        setTimeout(function () {
            readingTime();
            buildOverview();
        }, 500);
    }

    if ($('.promo__slides').length > 0) {
        buildPromoSlider();
    }

    initTieredBonus();
    initTierDiscount();

    if (document.getElementById('bundle_compose')) {
        bcLog('Loading Bundle');
        loadBundle();
    } else {
        bcLog('No element for bundle');
    }

    if ($('input[name="address[phone]"]').length > 0) {
        $('input[name="address[phone]"]').usPhoneFormat({
            format: '(xxx) xxx-xxxx',
        });
    }

    /*$('.select-inline').select2({
        templateResult: formatBCOption
    });*/

    if ($('.shopping-cart-table').length > 0) {
        if (window.BOLD && window.BOLD.csp && window.BOLD.csp.app && window.BOLD.csp.app.cartDoctor) {
            for (var itemI in window.BOLD.csp.app.cartDoctor.cart.items) {
                var item = window.BOLD.csp.app.cartDoctor.cart.items[itemI];
                if (item.original_price !== item.price) {
                    $('.shopping-cart-table tr[data-id="' + item.id + '"] .icon-coin').removeClass('hidden');

                    var oldPrice = item.original_price / 100;
                    $('.shopping-cart-table tr[data-id="' + item.id + '"] .unit-price > span').after(' <span class="strike" style="font-size: 0.7em">$' + oldPrice + '</span>');
                }
            }
        }
    }

    $('[data-toggle="tooltip"]').tooltip();

    jQuery('#update_company_info').on('click', function (e) {
        e.preventDefault();

        jQuery('#table-company-info').hide();
        jQuery('#form_company').show();

    });

    jQuery('#update_profile_info').on('click', function (e) {
        e.preventDefault();

        jQuery('#table-profile-info').hide();
        jQuery('#form_profile').show();

    });

    $('[name="quantity"]').on('change', function (e) {

        var parent = $(this).closest('form');
        setTimeout(function () {
            console.debug('checkVariantSelected name="quantity"');
            if ($('.select-inline', parent).length > 0) {
                checkVariantSelected($('.select-inline', parent));
            } else {
                checkVariantSelected($('[name="id"]', parent));
            }
            //$('.select-inline', parent).trigger('change');
        }, 150);

    });
    $('.minus-btn, .plus-btn').on('click', function (e) {

        var parent = $(this).closest('form');
        setTimeout(function () {
            $('.select-inline', parent).trigger('change');
        }, 150);
    })


    var options = jQuery('.td-printers select option');
    options.removeProp('selected');
    $(options[0]).removeProp('selected');
    if (jQuery('.td-printers').length > 0) {

        var customerId = $('#form_company').data('customer-id');


        $.ajax({
            url: "https://app.breathingcolor.com/query?customer_id=" + customerId,
            data: '',
            method: 'get',
            success: function (data) {
                if (data.error == 0) {
                    if (data.countryCode === 'US') {
                        $('.section-loyalty').show();
                    }
                } else {
                    bcLog('An error is occurred. Please try again.');
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {

                bcLog('An error is occurred. Please try again.');
            }
        });

        $("#form_company").validate({
            errorElement: "span"
        });


        $('.select2').select2();
        var selected = jQuery('.td-printers').data('selected').split(',');
        jQuery('.td-printers select option')[0].remove();
        jQuery('.td-printers select').addClass("ui fluid dropdown");
        jQuery('.td-printers select').attr('multiple', 'multiple');
        jQuery('.td-printers select').attr('size', 6);
        jQuery('.td-printers select').css({'min-height': '120px', 'width': '100% !important'});


        if (jQuery('.td-printers').data('selected') === "") {
            jQuery('.td-printers select option').removeAttr('selected');
            $.ajax({
                url: "https://app.breathingcolor.com/customers/default-printer",
                data: 'customer_id=' + customerId,
                method: 'get',
                success: function (data) {
                    if (data.error == 0) {
                        $('.td-printers').data('default', data.printer);
                        jQuery('.td-printers select option[value="' + data.printer.replace('"', '\\"') + '"]').attr('selected', 'selected');

                    } else {
                        bcLog('An error is occurred. Please try again.');
                    }
                    $('.td-printers select').select2();
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    bcLog('An error is occurred. Please try again.');
                    $('.td-printers select').select2();
                }
            });
        } else {
            jQuery('.td-printers select option').removeAttr('selected');
            for (var i = 0; i < selected.length; i++) {
                for (var j = 0; j < options.length; j++) {
                    if (options[j].innerText == selected[i]) {
                        $(options[j]).prop('selected', 'selected');
                    }
                }
            }
            $('.td-printers select').select2();
        }


    }

    jQuery('#form_profile').on('submit', function (e) {
        e.preventDefault();

        var $cbx_group = $("input:checkbox[name='ink_types[]']");

        $cbx_group.prop('required', true);
        if ($cbx_group.is(":checked")) {
            $cbx_group.prop('required', false);
        }

        jQuery('#form_profile').LoadingOverlay("show");

        var customerId = $(this).data('customer-id');

        $.ajax({
            url: "https://app.breathingcolor.com/customers/" + customerId + "/profile-info",
            data: $('#form_profile').serialize(),
            method: 'post',
            success: function (data) {
                if (data.error == 0) {
                    window.location.reload();
                } else {
                    jQuery('#form_profile').LoadingOverlay("hide");
                    alert('An error is occurred. Please try again.');
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                jQuery('#form_profile').LoadingOverlay("hide");
                alert('An error is occurred. Please try again.');
            }
        });
    });


    jQuery('#form_company').on('submit', function (e) {
        e.preventDefault();
        if ($(this).valid()) {
            jQuery('#form_company').LoadingOverlay("show");

            var customerId = $(this).data('customer-id');

            var options = jQuery('.td-printers select option');
            var printers = [];
            for (var j = 0; j < options.length; j++) {
                if (options[j].selected === true
                    && options[j].value !== '') {
                    printers.push($(options[j]).text());
                }
            }

            $.ajax({
                url: "https://app.breathingcolor.com/customers/" + customerId + "/company-info",
                data: $('#form_company').serialize() + '&printers=' + printers.join(','),
                method: 'post',
                success: function (data) {
                    if (data.error == 0) {
                        window.location.reload();
                    } else {
                        jQuery('#form_company').LoadingOverlay("hide");
                        alert('An error is occurred. Please try again.');
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    jQuery('#form_company').LoadingOverlay("hide");
                    alert('An error is occurred. Please try again.');
                }
            });
        }
    });

    /*$('[name="quantity"]').on('change', function (e) {

        var parent = $(this).closest('form');
        setTimeout(function () {
            checkVariantSelected($('.select-inline', parent));
            // $('.select-inline', parent).trigger('change');
        }, 100);

    });*/
    $('.minus-btn, .plus-btn').on('click', function (e) {

        var parent = $(this).closest('form');
        setTimeout(function () {
            $('.select-inline', parent).trigger('change');
        }, 100);
    })

    jQuery('.custom-nav-tabs-local a').on('click', function (e) {

        var hash = $(this).attr("href");
        if (hash.match(/^#\w+/g)) {
            e.preventDefault();
            var node = $(hash);
            node.attr("id", "");
            document.location.hash = hash;
            node.attr("id", hash.replace("#", ""));
        }
    });

    $('html').click(function (e) {

        if (!$(e.target).hasClass('.dropdown-toggle') &&
            !$(e.target).hasClass('.dropdown-menu') &&
            $(e.target).parents('.dropdown-menu').length == 0) {

            if ($('.main-parent-cart .cart .dropdown.open').length > 0) {
                $('.main-parent-cart .cart .dropdown').removeClass('open');
            }
        }
    });

    $('.main-parent-cart .cart .dropdown-toggle').on('click', function () {
        var parent = $(this).closest('.main-parent-cart');

    });


    jQuery('.select-inline').each(function () {
        if (!$(this).hasClass('initialized-select')) {
            initializeSelect(this);
            $(this).select2({
                templateResult: formatBCOption
            });
        }

    })

    $('.quick_item form').on('submit', function (e) {
        e.preventDefault();
        var _parent = $(this);
        var _btn = $(this).find('.add-to-cart');

        var variant_id = _parent.find('.form-control.select-inline').val();
        var quantity = Math.max(1, parseInt(_parent.find('.input-counter').find('input').val()));
        Shopify.addItem(variant_id, quantity);

        $('.main-parent-cart .cart .dropdown-toggle').trigger('click');

        typeof quick_view_loader !== 'undefined' && quick_view_loader.wait(_btn);
    });

    countDown(true);
    productSmall();
    expanderList();
    collapseBlock();
    listingModeToggle();
    slideColumn();
    inputCounter();
    footerCollapse();
    backToTop();
    searchDropDown();
    cartSlideIni();
    radioClickList();
    calendarDatepicker();
    priceSlider();
    verticalCarousel();
    gridGalleryMasonr();
    headerViewSearch();
    videoPopup();
    videoPost();

    if ($('.slider-blog-fluid').length > 0) {
        setSlickGallery($('.slider-blog-fluid'), 1, 1, 1, 1, 1, 'slickSlider');
    }
    if ($('.brands-page-js').length > 0) {
        setSlickGallery($('.brands-page-js'), 6, 5, 4, 2, 1, 'carousel');
    }
    if ($('.carousel-menu-2').length > 0) {
        setSlickGallery($('.carousel-menu-2'), 5, 5, 4, 3, 2, 'carousel');
    }
    if ($('.bigGallery').length > 0) {
        setSlickGallery($('.bigGallery'), 3, 3, 3, 2, 1, 'carousel');
    }
    if ($('.mobileGallery').length > 0) {
        setSlickGallery($('.mobileGallery'), 1, 1, 1, 1, 1, 'carousel');
    }
    if ($('.carousel-products-2').length > 0) {
        //setSlickGallery($('.carousel-products-2'), 4, 3, 3, 2, 1, 'carousel');
    }
    if ($('.carousel-products-3').length > 0) {
        setSlickGallery($('.carousel-products-3'), 2, 2, 2, 2, 1, 'carousel');
    }
    if ($('.carousel-products-33211').length > 0) {
        setSlickGallery($('.carousel-products-33211'), 3, 3, 2, 1, 1, 'carousel');
    }
    if ($('.mobileGallery-product').length > 0) {
        setSlickGallery($('.mobileGallery-product'), 1, 1, 1, 1, 1, 'carousel');
    }
    if ($('.mobileGallery-product-big').length > 0) {
        setSlickGallery($('.mobileGallery-product-big'), 2, 2, 2, 2, 1, 'carousel');
    }
    if ($('.slider-blog').length > 0) {
        setSlickGallery($('.slider-blog'), 1, 1, 1, 1, 1, 'carousel');
    }

    /* header */
    initStuck();
    //mobileparentcart();
    mobileParentCurrency();
    mobileParentLanguage();
    $(window).trigger('resize');

    setTimeout(function () {
        $("#pageContent").addClass("show");
        $(".breadcrumbs").length && $(".breadcrumbs").addClass("show");
    }, 0);

    initProductOptions();
});


/* header */
var $stucknav = $('.stuck-nav');
//menu
var $menu = $('.header-menu');
var $menuparentbox = $('.menu-parent-box');
var $stuckmenuparentbox = $('.stuck-menu-parent-box');
//mobile menu
var $mobilemenuparentbox = $('.mobile-parent-menu');
var $menumobile = $mobilemenuparentbox.children();
//cart
var $stuckcartparentbox = $('.stuck-cart-parent-box');
var $cartparentbox = $('.main-parent-cart');
var $mobileparentcart = $('.mobile-parent-cart');
var $cart = $('header .cart');
//currency
var $currencyparentbox = $('.main-parent-currency');
var $mobileparentcurrency = $('.mobile-parent-currency');
var $currency = $("header .currency");
//language
var $languageparentbox = $('.main-parent-language');
var $mobileparentlanguage = $('.mobile-parent-language');
var $language = $("header .language");

/**
 * Stuck init. Properties: on/off
 * @value = 'off', default empty
 */
function initStuck(value) {
    if ($stucknav.hasClass('disabled')) return;

    var value = value || false,
        ie = (getInternetExplorerVersion() !== -1) ? true : false;

    if (value == 'off') return false;
    var n = 0;
    $(window).scroll(function () {
        if (window.innerWidth >= 1025) {
            var HeaderTop = $('.desktop-header.header-06').innerHeight() - 20;

            if ($(window).scrollTop() > HeaderTop) {
                $('.desktop-header.header-06').addClass('scrolled');

            } else {
                if ($('.desktop-header.header-06').hasClass('scrolled')) {
                    $('.desktop-header.header-06').removeClass('scrolled');


                }
            }

        }
    });
}

// function mobileparentcart() {
//   $(window).resize(function () {
//     setTimeout(function () {
//       if (window.innerWidth < 1025) {
//         if ($mobileparentcart.children().lenght) return false;
//         if ($('.stuck').length) return false;
//         $mobileparentcart.append($cart.detach());
//       } else {
//         if ($cartparentbox.children().lenght) return false;
//         if ($('.stuck').length) return false;
//         $cartparentbox.append($cart.detach());
//       }
//     }, 0)
//   });
// }

function mobileParentCurrency() {
    $(window).resize(function () {
        setTimeout(function () {
            if (window.innerWidth < 1025) {
                if ($mobileparentcurrency.children().lenght) return false;
                $mobileparentcurrency.append($currency.detach());
            } else {
                if ($currencyparentbox.children().lenght) return false;
                $currencyparentbox.append($currency.detach());
            }
        }, 0)
    });
}

function mobileParentLanguage() {
    $(window).resize(function () {
        setTimeout(function () {
            if (window.innerWidth < 1025) {
                if ($mobileparentlanguage.children().lenght) return false;
                $mobileparentlanguage.append($language.detach());
            } else {
                if ($languageparentbox.children().lenght) return false;
                $languageparentbox.append($language.detach());
            }
        }, 0)
    });
}


function setSlickGallery(value) {
    if (value.length == 0) return false;
    var arr = $.makeArray(arguments);
    var fn = window[arr[arr.length - 1]];
    if (typeof fn === "function") fn(arr[0], arr[1], arr[2], arr[3], arr[4], arr[5]);
}

/*
Mobile Menu.
Variables: mobile_menu_close, mobile_menu_back from theme.liquid
*/
if ($('.mobile-menu-toggle').length || $('.mobile-categories-toggle').length) {
    if (typeof $(".mobile-menu-toggle").initMM !== 'undefined') {
        $(".mobile-menu-toggle").initMM({
            enable_breakpoint: true,
            mobile_button: true,
            breakpoint: 1024,
            menu_class: "mainmenu-mobile",
            close_button_name: mobile_menu_close,
            back_button_name: mobile_menu_back
        });
    }
}
if ($('.mobile-categories-toggle').length) {
    if (typeof $(".mobile-categories-toggle").initMM !== 'undefined') {
        $(".mobile-categories-toggle").initMM({
            enable_breakpoint: true,
            mobile_button: true,
            breakpoint: 1024,
            menu_class: "layout2-mobile",
            close_button_name: mobile_menu_close,
            back_button_name: mobile_menu_back
        });
    }
}

jQuery(function ($) {
    function initFormGroup($obj) {
        $obj.each(function () {
            var $this = $(this);
            var iconObj = $this.find('.input-group-addon');
            if (iconObj.length) {
                $this.click(function () {
                    formGroupObj.removeClass('active');
                    $this.addClass('active');
                })
            }
        });
    };
    var formGroupObj = $('.form-group');
    if (formGroupObj.length) {
        initFormGroup(formGroupObj);
    }
    ;
});

/*
Gallery Popup (gallery-layout.html)
*/
jQuery(function ($) {
    "use strict";
    if ($('.gallery, .gallery-masonry').length) {
        $('.gallery .zomm-gallery, .gallery-masonry .zomm-gallery').magnificPopup({
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    }
});

jQuery(function ($) {
    "use strict";

    var newSelection = "";

    $(".filter-nav div").click(function () {
        $("#all-filter-content").hide(0);
        $("#all-filter-content").fadeIn(500);

        $(".filter-nav div").removeClass("current");
        $(this).addClass("current");

        newSelection = $(this).attr("rel");

        $(".item").not("." + newSelection).fadeOut();
        $("." + newSelection).fadeIn();

        $("#all-filter-content").fadeIn(0);

    });
});

/* slider-scroll */
$.fn.sliderScroll = function () {
    var $slider = this;

    if (!$slider.length) return false;

    var $nav = $slider.find('.nav-slider-scroll');

    $nav.on('click', 'li', function (e) {
        var wind_H = window.innerHeight,
            wind_W = window.innerWidth,
            $li = $nav.children(),
            $item,
            item_top,
            item_H,
            scroll_to,
            responsive = (wind_W < 768 && wind_H > 562) ? (wind_H - 562) / 2 : 0,
            eq = 0,
            i = 0;

        for (; i < $li.length; i++) {
            if ($li.get(i) === this)
                eq = i;
        }

        $item = $slider.find('.item').eq(eq),
            item_top = $item.offset().top,
            item_H = $item.outerHeight(),
            scroll_to = item_top - wind_H / 2 + item_H / 2;

        $('html, body').animate({
            scrollTop: scroll_to + responsive
        }, 500);

        e.preventDefault();
        e.stopPropagation();
        return false;
    });

    $(window).on('resize scroll load', function () {
        var wind_H = window.innerHeight,
            wind_W = window.innerWidth,
            $items = $slider.find('.item'),
            nav_marg_bottom = parseInt($nav.find('li:last-child a').css('margin-bottom')),
            nav_H = $nav.innerHeight() - nav_marg_bottom - 14,
            nav_top = $nav.offset().top,
            $last_item = $slider.find('.item:last-child'),
            last_item_top = $last_item.offset().top,
            last_item_H = $last_item.outerHeight(),
            last_item_max = last_item_top + last_item_H / 2,
            $first_item = $slider.find('.item').eq(0),
            first_item_top = $first_item.offset().top,
            first_item_H = $first_item.outerHeight(),
            first_item_max = first_item_top + first_item_H / 2,
            pos_top = 0,
            responsive = (wind_W < 768 && wind_H > 562) ? (wind_H - 562) / 2 : 0,
            i = 0;

        if (last_item_max < pageYOffset + wind_H / 2 - responsive)
            pos_top = last_item_max - nav_H / 2 - pageYOffset;
        else if (first_item_max > pageYOffset + wind_H / 2 - responsive)
            pos_top = first_item_max - nav_H / 2 - pageYOffset;
        else
            pos_top = wind_H / 2 - nav_H / 2 - responsive;

        $nav.css({
            'top': pos_top
        });

        for (; i < $items.length; i++) {
            var $item = $items.eq(i),
                this_bottom = $item.offset().top + $item.outerHeight(),
                eq;

            if (this_bottom > nav_top + nav_H / 2) {
                $nav.find('li').removeClass('active').eq(i).addClass('active');
                break;
            }
        }
    });
};


if ($(".l9-one-product-js").length) {
    l9rectangle();
    $(window).resize(l9rectangle);
}

function l9rectangle() {
    var $obj = $(".l9-one-product-js");
    $obj.find(".row").removeAttr("style");
    setTimeout(function () {
        var w_height = window.innerHeight;
        var y_pos = $obj.offset().top;
        var h_obj = $obj.outerHeight();
        var delta = parseInt(w_height - y_pos - h_obj);
        if (delta > 0) {
            $obj.find(".row").css("padding-bottom", delta);
        }
    }, 100);
}

var cssFix = function () {
    var u = navigator.userAgent.toLowerCase(),
        is = function (t) {
            return (u.indexOf(t) != -1)
        };
    $("html").addClass([
        (!(/opera|webtv/i.test(u)) && /msie (\d)/.test(u)) ? ('ie ie' + RegExp.$1) :
            is('firefox/2') ? 'gecko ff2' :
                is('firefox/3') ? 'gecko ff3' :
                    is('gecko/') ? 'gecko' :
                        is('opera/9') ? 'opera opera9' : /opera (\d)/.test(u) ? 'opera opera' + RegExp.$1 :
                            is('konqueror') ? 'konqueror' :
                                is('applewebkit/') ? 'webkit safari' :
                                    is('mozilla/') ? 'gecko' : '',
        (is('x11') || is('linux')) ? ' linux' :
            is('mac') ? ' mac' :
                is('win') ? ' win' : ''
    ].join(''));
}();

function getInternetExplorerVersion() {
    var rv = -1;
    if (navigator.appName == 'Microsoft Internet Explorer') {
        var ua = navigator.userAgent;
        var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
        if (re.exec(ua) != null)
            rv = parseFloat(RegExp.$1);
    } else if (navigator.appName == 'Netscape') {
        var ua = navigator.userAgent;
        var re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
        if (re.exec(ua) != null)
            rv = parseFloat(RegExp.$1);
    }
    return rv;
}

if (getInternetExplorerVersion() !== -1) {
    $("html").addClass("ie");
}


// logo for retina
jQuery(function ($) {
    if ('devicePixelRatio' in window && window.devicePixelRatio == 2) {
        $("body").addClass('mac');
        var img_to_replace = jQuery('.footer-logo img, .logo img').get();
        for (var i = 0, l = img_to_replace.length; i < l; i++) {
            var src = img_to_replace[i].src;
            src = src.replace(/\.(png|jpg|gif)+$/i, '@2x.$1');
            img_to_replace[i].src = src;
        }
        ;
        $(".bigGallery").each(function () {
            $('body').addClass('ipad-bigGallery');
        });
    }
});

jQuery(function ($) {
    if (!$('#pageContent .collapse-block').hasClass(':not(.open)')) {
        $(".collapse-block_title").click(function () {
            $('.vertical-carousel').slick('setPosition').slick('setPosition');
        });
    }
});

/*
header language and currency(dropdown)
*/
jQuery(function ($) {
    function initDropdown($dropdown) {
        $dropdown.each(function () {
            var $this = $(this);
            var $title = $this.find('.title-value');
            var $activeElement = $this.find('.dropdown-menu li.active');
            if ($activeElement.length) {
                $title.text($activeElement.data('top-value'));
            } else {
                var $firstElement = $this.find('.dropdown-menu li').first();
                $title.text($firstElement.data('top-value'));
            }
        });
    }

    var $dropdownObj = $('.select-change');
    initDropdown($dropdownObj);
    $dropdownObj.on('click', 'li', function () {
        var $this = $(this);

        $this.siblings().removeClass('active');
        $this.addClass('active');
        $this.closest('.select-change').find('.title-value').text($this.data('top-value'));
    });
});

/*
tabs(custom)
*/
jQuery(function ($) {
    $.fn.ttTabs = function (options) {
        function ttTabs(tabs) {
            var $tabs = $(tabs),
                $head = $tabs.find('.tt-tabs__head'),
                $head_ul = $head.find('> ul'),
                $head_li = $head_ul.find('> li'),
                $head_span = $head_li.find('> span'),
                $border = $head.find('.tt-tabs__border'),
                $body = $tabs.find('.tt-tabs__body'),
                $body_li = $body.find('> div'),
                anim_tab_duration = options.anim_tab_duration || 500,
                anim_scroll_duration = options.anim_scroll_duration || 500,
                breakpoint = 1025,
                scrollToOpenMobile = (options.scrollToOpenMobile !== undefined) ? options.scrollToOpenMobile : true,
                singleOpen = (options.singleOpen !== undefined) ? options.singleOpen : true,
                toggleOnDesktop = (options.toggleOnDesktop !== undefined) ? options.toggleOnDesktop : true,
                effect = (options.effect !== undefined) ? options.effect : 'slide',
                offsetTop = (options.offsetTop !== undefined) ? options.offsetTop : '',
                goToTab = options.goToTab,
                $btn_prev = $('<div>').addClass('tt-tabs__btn-prev disabled'),
                $btn_next = $('<div>').addClass('tt-tabs__btn-next'),
                btn_act = false;

            function _closeTab($li, desktop) {
                var anim_obj = {
                    duration: anim_tab_duration,
                    complete: function () {
                        $(this).removeAttr('style');
                    }
                };

                function _anim_func($animElem) {
                    if (effect === 'toggle') {
                        $animElem.hide().removeAttr('style');
                    } else if (effect === 'slide') {
                        $animElem.slideUp(anim_obj);
                    } else {
                        $animElem.slideUp(anim_obj);
                    }
                };

                var $animElem;

                if (desktop || singleOpen) {
                    $head_li.removeClass('active');
                    $animElem = $body_li.filter('.active').removeClass('active').find('> div').stop();

                    _anim_func($animElem);
                } else {
                    var index = $head_li.index($li);

                    $li.removeClass('active');
                    $animElem = $body_li.eq(index).removeClass('active').find('> div').stop();

                    _anim_func($animElem);
                }
            };

            function _openTab($li, desktop, beforeOpen, afterOpen, trigger) {
                var index = $head_li.index($li),
                    $body_li_act = $body_li.eq(index),
                    $animElem,
                    anim_obj = {
                        duration: anim_tab_duration,
                        complete: function () {
                            if (afterOpen) afterOpen($body_li_act);
                        }
                    };

                function _anim_func($animElem) {
                    if (beforeOpen) beforeOpen($li.find('> span'));

                    if (effect === 'toggle') {
                        $animElem.show();
                        if (afterOpen) afterOpen($body_li_act);
                    } else if (effect === 'slide') {
                        $animElem.slideDown(anim_obj);
                    } else {
                        $animElem.slideDown(anim_obj);
                    }
                };

                $li.addClass('active');
                $animElem = $body_li_act.addClass('active').find('> div').stop();

                _anim_func($animElem);
            };

            function _replaceBorder($this, animate) {
                if ($this.length) {
                    var span_l = $this.get(0).getBoundingClientRect().left,
                        head_l = $head.get(0).getBoundingClientRect().left,
                        position = {
                            left: span_l - head_l,
                            width: $this.width()
                        };
                } else {
                    var position = {
                        left: 0,
                        width: 0
                    };
                }

                if (animate) $border.stop().animate(position, anim_tab_duration);
                else $border.stop().css(position);
            };

            function _correctBtns($li, func) {
                var span_act_l = $li.find('> span').get(0).getBoundingClientRect().left,
                    span_act_r = $li.find('> span').get(0).getBoundingClientRect().right,
                    head_pos = {
                        l: $head.get(0).getBoundingClientRect().left,
                        r: $head.get(0).getBoundingClientRect().right
                    };

                if (span_act_l < head_pos.l) {
                    _replace_slider(Math.ceil(head_pos.l - span_act_l), head_pos, false, function () {
                        func();
                    });
                } else if (span_act_r > head_pos.r) {
                    _replace_slider(Math.ceil(span_act_r - head_pos.r) * -1, head_pos, false, function () {
                        func();
                    });
                } else {
                    func();
                }
            };

            $head.on('click', '> ul > li > span', function (e, trigger) {
                var $this = $(this),
                    $li = $this.parent(),
                    wind_w = window.innerWidth,
                    desktop = wind_w > breakpoint,
                    trigger = (trigger === 'trigger') ? true : false;

                if ($li.hasClass('active')) {
                    if (desktop && !toggleOnDesktop) return;

                    _closeTab($li, desktop);

                    _replaceBorder('', true);
                } else {
                    _correctBtns($li, function () {
                        _closeTab($li, desktop);

                        _openTab($li, desktop,
                            function ($li_act) {
                                if (desktop) {
                                    var animate = !trigger;

                                    _replaceBorder($li_act, animate);
                                }
                            },
                            function ($body_li_act) {
                                if (!desktop && !trigger && scrollToOpenMobile) {
                                    var tob_t = $body_li_act.offset().top;
                                    $('html, body').stop().animate({scrollTop: tob_t}, {
                                        duration: anim_scroll_duration
                                    });
                                }
                            }
                        );
                    });
                }
            });

            $body.on('click', '> div > span', function (e) {
                var $this = $(this),
                    $li = $this.parent(),
                    index = $body_li.index($li);

                $head_li.eq(index).find('> span').trigger('click');
            });

            function _toTab(tab, scrollTo, focus) {
                var wind_w = window.innerWidth,
                    desktop = wind_w > breakpoint,
                    header_h = 0,
                    $sticky = $(offsetTop),
                    $openTab = $head_li.filter('[data-tab="' + tab + '"]'),
                    $scrollTo = $(scrollTo),
                    toTab = {};

                if (desktop && $sticky.length) {
                    header_h = $sticky.height();
                }

                if (!$openTab.hasClass('active')) {
                    toTab = {scrollTop: $tabs.offset().top - header_h};
                }

                $('html, body').stop().animate(toTab, {
                    duration: anim_scroll_duration,
                    complete: function () {
                        _correctBtns($openTab, function () {
                            _closeTab($openTab, desktop);

                            _openTab($openTab, desktop,
                                function ($li_act) {
                                    _replaceBorder($li_act, true);
                                },
                                function () {
                                    if ($scrollTo.length) {
                                        $('html, body').animate({scrollTop: $scrollTo.offset().top - header_h}, {
                                            duration: anim_scroll_duration,
                                            complete: function () {
                                                var $focus = $(focus);

                                                if ($focus.length) $focus.focus();
                                            }
                                        });
                                    }
                                }
                            );
                        })
                    }
                });
            };

            if ($.isArray(goToTab) && goToTab.length) {
                $(goToTab).each(function () {
                    var elem = this.elem,
                        tab = this.tab,
                        scrollTo = this.scrollTo,
                        focus = this.focus;

                    $(elem).on('click', function (e) {
                        _toTab(tab, scrollTo, focus);

                        e.preventDefault();
                        return false;
                    });
                });
            }

            function _btn_disabled(head_pos) {
                var span_pos = {
                    l: $head_li.first().find('> span').get(0).getBoundingClientRect().left,
                    r: $head_li.last().find('> span').get(0).getBoundingClientRect().right
                };

                if (span_pos.l < head_pos.l) $btn_prev.removeClass('disabled');
                else $btn_prev.addClass('disabled');

                if (span_pos.r > head_pos.r) $btn_next.removeClass('disabled');
                else $btn_next.addClass('disabled');
            };

            function _replace_slider(difference, head_pos, resize, afterReplace) {
                var ul_pos = parseInt($head_ul.css('left'), 10),
                    border_pos = parseInt($border.css('left'), 10),
                    duration = (!resize) ? anim_tab_duration : 0,
                    anim_pos = {
                        'left': ul_pos + difference
                    };

                if (resize) {
                    $head_ul.css(anim_pos);
                    _btn_disabled(head_pos);
                } else {
                    $border.animate({'left': border_pos + difference}, anim_tab_duration);

                    $head_ul.animate(anim_pos, {
                        duration: duration,
                        complete: function () {
                            _btn_disabled(head_pos);
                            if (afterReplace) afterReplace();
                            btn_act = false;
                        }
                    });
                }
            };

            $tabs.on('click', '.tt-tabs__btn-prev, .tt-tabs__btn-next', function () {
                var $btn = $(this);

                if ($btn.hasClass('disabled') || btn_act) return;

                btn_act = true;

                var head_pos = {
                    l: $head.get(0).getBoundingClientRect().left,
                    r: $head.get(0).getBoundingClientRect().right
                };

                if ($btn.hasClass('tt-tabs__btn-next')) {
                    $head_span.each(function (i) {
                        var $this = $(this),
                            this_r = $this.get(0).getBoundingClientRect().right;

                        if (this_r > head_pos.r) {
                            _replace_slider(Math.ceil(this_r - head_pos.r) * -1, head_pos);
                            return false;
                        }
                    });
                } else if ($btn.hasClass('tt-tabs__btn-prev')) {
                    $($head_span.get().reverse()).each(function (i) {
                        var $this = $(this),
                            this_l = $this.get(0).getBoundingClientRect().left;

                        if (this_l < head_pos.l) {
                            _replace_slider(Math.ceil(head_pos.l - this_l), head_pos);
                            return false;
                        }
                    });
                }
            });

            $(window).on('resize load', function () {
                var wind_w = window.innerWidth,
                    desktop = wind_w > breakpoint,
                    head_w = $head.innerWidth(),
                    li_w = 0;

                $head_li.each(function () {
                    li_w += $(this).innerWidth();
                });

                if (desktop) {
                    var $li_act = $head_li.filter('.active'),
                        $span_act = $li_act.find('> span');

                    if (!singleOpen && $span_act.length > 1) {
                        var $save_active = $li_act.first();

                        _closeTab('', desktop);
                        _openTab($save_active, desktop);
                    }

                    if (li_w > head_w) {
                        $head.addClass('slider').append($btn_prev).append($btn_next);

                        $head_ul.css({'margin-right': (li_w - $head.innerWidth()) * -1});

                        if ($span_act.length) {

                            var span_act_r = $span_act.get(0).getBoundingClientRect().right,
                                span_last_r = $head_span.last().get(0).getBoundingClientRect().right,
                                head_pos = {
                                    l: $head.get(0).getBoundingClientRect().left,
                                    r: $head.get(0).getBoundingClientRect().right
                                };

                            if (span_act_r > head_pos.r) {
                                _replace_slider(Math.ceil(span_act_r - head_pos.r) * -1, head_pos, true);
                            } else if (span_last_r < head_pos.r) {
                                _replace_slider(head_pos.r - span_last_r, head_pos, true);
                            }

                            _replaceBorder($span_act, false);
                        }

                    } else {
                        $head_ul.removeAttr('style');
                        $btn_prev.remove();
                        $btn_next.remove();
                        $head.removeClass('slider');
                        _replaceBorder($span_act, false);
                    }

                    $head.css({'visibility': 'visible'});
                } else {
                    $border.removeAttr('style');
                }
            });

            $head_li.filter('[data-active="true"]').find('> span').trigger('click', ['trigger']);

            return $tabs;
        };

        var tabs = new ttTabs($(this).eq(0));

        return tabs;
    };
    var $ttTabsObj = $('.tt-tabs');
    if ($ttTabsObj.length) {
        $ttTabsObj.ttTabs({
            singleOpen: false,
            anim_tab_duration: 270,
            anim_scroll_duration: 500,
            toggleOnDesktop: false,
            scrollToOpenMobile: false,
            effect: 'slide',
            offsetTop: '.tt-header[data-sticky="true"]',
            goToTab: [
                {
                    elem: '.tt-product-head__review-count',
                    tab: 'review',
                    scrollTo: '.tt-review__comments'
                },
                {
                    elem: '.tt-product-head__review-add, .tt-review__head > a',
                    tab: 'review',
                    scrollTo: '.tt-review__form',
                    focus: '#reviewName'
                }
            ]
        });
    }
});


/*
blog-thumb arrow carusel
*/
jQuery(function ($) {

    $('body').on('click', '.klaviyo-bis-trigger', function () {
        setTimeout(function () {
            var id = $('[name="id"]').val();
            if (!id) {
                id = $($('#klaviyo-bis-iframe')[0].contentWindow.document).find('#variants option[value]').attr('value');
            }
            console.log('variants id', id);
            $($('#klaviyo-bis-iframe')[0].contentWindow.document).find('#variants').val(id);
        }, 500);
    });

    $(window).on('load resize ready', function () {
        setTimeout(function () {
            var $objParent = $('.blog-thumb'),
                $obj = $objParent.find('.img'),
                $objParentArrow = $objParent.closest('.carousel-products-mobile').find('.slick-arrow');

            if ($obj.length && $objParentArrow.length) {

                $.fn.findHeight = function () {
                    var $blocks = $(this),
                        maxH = $blocks.eq(0).height();

                    $blocks.each(function () {
                        maxH = ($(this).height() > maxH) ? $(this).height() : maxH;
                    });

                    return maxH / 2;
                };

                var $objHeight = $obj.findHeight(),
                    $objParentError = parseInt($objParent.css('marginTop'));


                $objParentArrow.css({
                    'top': $objHeight + $objParentError + 'px'
                });
            }
        }, 225);
    });
});

/*
simple menu
*/
jQuery(function ($) {
    function initSimpleMenu(obj, objValue) {
        obj.each(function () {
            var $this = $(this);
            var objWidt = $this.width();
            if (objWidt > objValue) {
                $this.closest('ul').addClass('large-width');
            }
        });
    }

    var headerMenuObj = $('.header-menu .multicolumn ul'),
        headerMenuValue = 290,
        verticalMenuObj = $('.menu-vertical .multicolumn ul'),
        verticalMenuValue = 207;

    if (headerMenuObj.length) {
        initSimpleMenu(headerMenuObj, headerMenuValue);
    }
    ;
    if (verticalMenuObj.length) {
        initSimpleMenu(verticalMenuObj, verticalMenuValue);
    }
    ;
});


/*
touch-device and gallery(mobile)
*/
jQuery(function ($) {
    function is_touch_device() {
        return !!('ontouchstart' in window) || !!('onmsgesturechange' in window);
    };

    function initgalleryObj($obj) {
        $obj.on('touchend', function () {
            var $this = $(this);
            if (!$this.hasClass('gallery-click')) {
                $obj.removeClass('gallery-click finish-animation');
                $this.addClass('gallery-click');
                setTimeout(function () {
                    $this.addClass('finish-animation');
                }, 300);
            }
        });
    };
    if (is_touch_device()) {
        var galleryObj = $('.gallery-content figure');
        $('body').addClass('touch-device');
        if (galleryObj.length) {
            initgalleryObj(galleryObj);
        }
        ;
    }
    ;
});

/*
sticky(product-05.html)
*/
jQuery(function ($) {
    var airStickyObj = $('.airSticky');
    var tabObj = $('.tt-tabs .tt-tabs__head > ul > li');
    if (airStickyObj.length) {
        $(window).on('resize load', function () {
            var currentW = window.innerWidth || $(window).width();
            if (currentW >= 789) {
                airStickyObj.airStickyBlock({
                    debug: false,
                    stopBlock: '.airSticky_stop-block',
                    offsetTop: 10,
                });
            }
            ;
        });
        $(document).bind('resize scroll', tabObj, function () {
            airStickyObj.trigger('render.airStickyBlock');
        });
    }
    ;
});


/*
banner first-child
*/
jQuery(function ($) {
    $(window).on('resize load', function () {
        function initbannerObj($obj) {
            $obj.each(function () {
                var $this = $(this);
                if ($this.is(':visible')) {
                    $this.addClass('first-child');
                    return false;
                }
            });
        };
        var bannerObj = $('.promo-box .block-table-cell').children().removeClass('first-child');
        if (bannerObj.length) {
            initbannerObj(bannerObj);
        }
        ;
    });
});

/*
Hover
data-c="" data-ac=""
data-bgc="" data-abgc=""
data-borc="" data-aborc=""

*/
var hoverColors = {
    params: {
        baseColor: 'data-c',
        activeColor: 'data-ac',
        bgBaseColor: 'data-bgc',
        bgActiveColor: 'data-abgc',
        borderBaseColor: 'data-borc',
        borderActiveColor: 'data-aborc',
    },
    init: function () {
        var attrName = this.params;
        var he = $('[data-hovercolors]');
        if (he.length == 0) return false;
        he.each(function () {
            hoverColors.getCurrentColors($(this), attrName.baseColor, attrName.bgBaseColor, attrName.borderBaseColor);
        });
    },
    initEvents: function () {
        var attrName = this.params;
        $('body').on({
                mouseenter: function () {
                    hoverColors.getCurrentColors($(this), attrName.activeColor, attrName.bgActiveColor, attrName.borderActiveColor);
                },
                mouseleave: function () {
                    hoverColors.getCurrentColors($(this), attrName.baseColor, attrName.bgBaseColor, attrName.borderBaseColor);
                }
            }, '[data-hovercolors]'
        );
    },
    getCurrentColors: function (_, attr1, attr2, attr3) {
        hoverColors.setCurrentColors(_, attr1, attr2, attr3);
        var ac = _.find('[' + attr1 + ']');
        if (ac.length == 0) return false;
        ac.each(function () {
            hoverColors.setCurrentColors($(this), attr1, attr2, attr3);
        });
    },
    setCurrentColors: function (_, attr1, attr2, attr3) {
        var c = _.attr(attr1);
        _.css('color', c);

        hoverColors.setCurrentBgColor(_, attr2);
        hoverColors.setCurrentBorderColor(_, attr3);

        return false;
    },
    setCurrentBgColor: function (_, attr) {
        var a = _.attr(attr);
        if (typeof a !== typeof undefined && a !== false) {
            _.css('background', a);
        }
    },
    setCurrentBorderColor: function (_, attr) {
        var a = _.attr(attr);
        if (typeof a !== typeof undefined && a !== false) {
            _.css('border-color', a);
        }
    }
}
hoverColors.initEvents();


$(document)
    .on('shopify:section:load', eventHandler)
    .ready(function () {
        $('[data-sectionname]').each(function () {
            $(this).initSection()
        });
    });

function eventHandler(e) {
    $('#' + e.target.id).find('[data-sectionname]').initSection();
}

$.fn.initSection = function () {
    var _ = this;
    var n = _.data('sectionname');
    switch (n) {
        case ("index_productsfeatured"):
            _.find('.carousel-products-1').initSlick(3, 2, 1);
            break;
        case ("index_brands"):
            _.find('.carousel-brands').initSlick(4, 2, 1);
            break;
        case ("index_instagram"):
            _.index_instagram();
            break;
        case ("index_sliderscroll"):
            _.index_sliderscroll();
            break;
        case ("slider_withbanners"):
            _.find('.slick-slider-content').dotSlick();
            break;
        case ("index_verticaltabs"):
            _.find('.nav-tabs--carusel').verticalTabs();
            break;
        case ("index_horizontaltabs"):
            _.horizontalTabs();
            break;
        case ("index11_products"):
            _.find('.grid').initIsotope();
            break;
        case ("layout2testimonials"):
            _.find('.testimonialsAsid').dotSlick();
            break;
        case ("index_revolution"):
            _.find('.slider-revolution').initRevolution();
            break;
        case ("lookbook"):
            _.find('.carousel-look-book').initLookbook(3, 2, 1, 1);
            break;
        default:
            break;
    }
}

$.fn.index_sliderscroll = function () {
    this.find('.slider-scroll').sliderScroll();
}

$.fn.index_instagram = function () {
    var m = this.find('[data-userid]');
    if (!(typeof Instafeed === 'function')) {
        m.replaceWith('<span class="text-center" style="display: inherit;">Save and reload page.</span>');
        return false;
    }

    var a = m.attr('id');
    var userid = m.data('userid');
    var clientId = m.data('clientid');
    var accesstoken = m.data('accesstoken');
    var count = m.data('count');

    var feed = new Instafeed({
        target: a,
        get: 'user',
        userId: userid,
        clientId: clientId,
        limit: count,
        sortBy: 'most-liked',
        resolution: "standard_resolution",
        accessToken: accesstoken,
        template: '<a href="{{link}}" target="_blank"><img src="{{image}}" /></a>'
    });
    feed.run();
}

$.fn.initLookbook = function (lg, md, sm, xs) {
    this.slick({
        slidesToShow: lg,
        slidesToScroll: lg,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: md,
                    slidesToScroll: md
                }
            },
            {
                breakpoint: 798,
                settings: {
                    slidesToShow: sm,
                    slidesToScroll: sm
                }
            }, {
                breakpoint: 480,
                settings: {
                    slidesToShow: xs,
                    slidesToScroll: xs
                }
            }]
    });
}
$.fn.initSlick = function (md, sm, xs) {
    this.slick({
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: md,
                    slidesToScroll: md
                }
            },
            {
                breakpoint: 798,
                settings: {
                    slidesToShow: sm,
                    slidesToScroll: sm
                }
            }, {
                breakpoint: 480,
                settings: {
                    slidesToShow: xs,
                    slidesToScroll: xs
                }
            }]
    });
}
$.fn.dotSlick = function () {
    this.slick({
        infinite: true,
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
    });
}

$.fn.verticalTabs = function () {
    var _ = this;
    var tabs = {
        init: function () {
            tabs.initTabSlider();
            _.find('.active a').trigger('click');
        },
        initTabSlider: function () {
            var currentW = window.innerWidth || $(window).width();
            _.each(function () {
                $(this).find('a').each(function () {
                    $(this).click(function () {
                        $(this).unbind();
                        var tab = $(this).attr("href");
                        var clone = tab + "-clone";
                        $(tab).empty();
                        $(clone).children().clone().appendTo($(tab));
                        var $obj = $(tab).find(".carouselTab1");
                        $obj.css("visibility", "hidden");
                        if ($obj.length == 0) return false;
                        setTimeout(function () {
                            $obj.hide().css("visibility", "visible").fadeIn(0);
                            currentW <= 791 && $obj.initSlick(2, 2, 1);
                        }, 5);
                    });
                });
            });
        }
    }
    $(window).on('resize', function () {
        tabs.init();
    });
    tabs.init();
}

$.fn.horizontalTabs = function () {
    var _ = this;
    $(document).on('click', '.tabs-wrapper .nav-tabs--carusel a', function () {
        var $this = $(this),
            $this_tab = $this.parents('.tabs-wrapper'),
            id = $this.attr('href'),
            $tab = $this_tab.find(id),
            $clone = $this_tab.find(id + '-clone');

        $clone.children().clone().appendTo($tab.empty());
        $tab.find('.carousel-products').initSlick(3, 2, 1);
        $tab.find('.grid').length && $tab.find('.grid').isotope({
            itemSelector: '.element-item',
            layoutMode: 'masonry',
            masonry: {
                columnWidth: '.element-item'
            }
        });

        var block_title = _.find('.block-title');
        block_title.length && block_title.html($this.html());

    });

    setTimeout(function () {
        _.find('.tabs-wrapper .nav-tabs--carusel .active a').trigger('click');
    }, 1000)
}

$.fn.initIsotope = function () {
    var $grid = this;
    var isotopeGrid = {
        grid: $grid,
        init: function () {
            var _ = this;
            if (_.grid.length == 0) return false;
            this.grid.isotope({
                itemSelector: '.element-item',
                layoutMode: 'masonry',
                masonry: {
                    columnWidth: '.element-item'
                }
            });
            var filterFns = {
                numberGreaterThan50: function () {
                    var number = $(this).find('.number').text();
                    return parseInt(number, 10) > 50;
                },
                ium: function () {
                    var name = $(this).find('.name').text();
                    return name.match(/ium$/);
                }
            };
            $('.nav-tab-filter').on('click', 'button', function () {
                var filterValue = $(this).attr('data-filter');
                // use filterFn if matches value
                filterValue = filterFns[filterValue] || filterValue;
                _.grid.isotope({
                    filter: filterValue
                });
            });
            $('.button-group').each(function (i, buttonGroup) {
                var $buttonGroup = $(buttonGroup);
                $buttonGroup.on('click', 'button', function () {
                    $buttonGroup.find('.is-checked').removeClass('is-checked');
                    $(this).addClass('is-checked');
                });
            });
            $(".filter-isotop").length && $(".filter-isotop").find(".is-checked").trigger("click");
        }
    };
    setTimeout(function () {
        isotopeGrid.init();
    }, 1000);
}

//REVOLUTION SLIDER (function to reset the plug on the breakpoints)

$.fn.initRevolution = function () {

    if ($('body').find('.revolution_included').length == 0) {
        this.replaceWith('<span class="text-center" style="display: inherit;">Save and reload page.</span>');
        return false;
    }

    function click_to_play_video() {
        var $this = $(this),
            $video = $this.find('li video');

        if (!$video.length) return;

        $video.on('play', function () {
            var $btn = $(this).parents('li').find('.video-play');

            $btn.addClass('pause');
            $(this).parents('.tp-caption.fullscreenvideo').addClass('click-video');
        });

        $video.on('pause ended', function () {
            var $btn = $(this).parents('li').find('.video-play');

            $btn.removeClass('pause');
        });

        $this.find('.video-play').on('click', function (e) {
            var $video = $(this).parents('li').find('video');

            $video.trigger('click');
            e.preventDefault();
            e.stopPropagation();
            return false;
        });

        $this.on('revolution.slide.onbeforeswap', function (event, data) {
            $(this).find('.tp-caption.fullscreenvideo').removeClass('click-video');
        });
    };

    function autoplay_video(elem) {
        var $get_sliders = $(this);

        $get_sliders.each(function () {
            var $slider = $(this);

            var set_event = function () {
                $slider.on('revolution.slide.onchange', function (event, data) {
                    var $this = $(this),
                        $active_slide = $this.find('li').eq(data.slideIndex - 1),
                        $video = $active_slide.find('video'),
                        autoplay = $active_slide.find('.tp-caption').attr('data-autoplay');

                    if ($video.length && autoplay === 'true') {
                        var video = $video.get(0);

                        video.currentTime = 0;

                        $slider.one('revolution.slide.onafterswap', function (event, data) {
                            if (video.paused) {
                                video.play();
                            }
                        });
                    }
                });
            };

            if ($slider.hasClass('revslider-initialised')) {
                set_event();
            } else {
                $slider.one('revolution.slide.onloaded', function () {
                    set_event();
                });
            }
        });
    };

    $.fn.resizeRevolution = function (options, new_rev_obj, bp_arr, revdelay) {
        if (!$(this).length || !$(options.slider).length || !options.breakpoints) return false;

        var wrapper = this,
            slider = options.slider,
            breakpoints = options.breakpoints,
            fullscreen_BP = options.fullscreen_BP || false,
            new_rev_obj = new_rev_obj || {},
            bp_arr = bp_arr || [],
            rev_obj = {
                dottedOverlay: "none",
                delay: revdelay,
                startwidth: 1920,
                hideThumbs: 200,
                hideTimerBar: "on",

                thumbWidth: 100,
                thumbHeight: 50,
                thumbAmount: 5,

                navigationArrows: "none",

                touchenabled: "on",
                onHoverStop: "on",

                swipe_velocity: 0.7,
                swipe_min_touches: 1,
                swipe_max_touches: 1,
                drag_block_vertical: false,

                parallax: "mouse",
                parallaxBgFreeze: "on",
                parallaxLevels: [7, 4, 3, 2, 5, 4, 3, 2, 1, 0],

                keyboardNavigation: "off",

                navigationHAlign: "center",
                navigationVAlign: "bottom",
                navigationHOffset: 0,
                navigationVOffset: 20,

                soloArrowLeftHalign: "left",
                soloArrowLeftValign: "center",
                soloArrowLeftHOffset: 20,
                soloArrowLeftVOffset: 0,

                soloArrowRightHalign: "right",
                soloArrowRightValign: "center",
                soloArrowRightHOffset: 20,
                soloArrowRightVOffset: 0,

                shadow: 0,

                spinner: "",
                h_align: "left",

                stopLoop: "off",
                stopAfterLoops: -1,
                stopAtSlide: -1,

                shuffle: "off",

                autoHeight: "off",
                forceFullWidth: "off",

                hideThumbsOnMobile: "off",
                hideNavDelayOnMobile: 1500,
                hideBulletsOnMobile: "off",
                hideArrowsOnMobile: "off",
                hideThumbsUnderResolution: 0,

                hideSliderAtLimit: 0,
                hideCaptionAtLimit: 0,
                hideAllCaptionAtLilmit: 0,
                startWithSlide: 0,
                fullScreenOffsetContainer: ""
            };

        $.extend(rev_obj, new_rev_obj);

        var get_Slider = function ($sliderWrapp) {
            return $sliderWrapp.find(slider);
        };

        var get_current_bp = function () {
            var wind_W = window.innerWidth;

            for (var i = 0; i < breakpoints.length; i++) {
                var bp = breakpoints[i];

                if (!breakpoints.length) return false;

                if (wind_W <= bp) {
                    if (i === 0) {
                        return bp;
                    } else {
                        if (bp > breakpoints[i - 1])
                            return bp;
                    }
                } else if (wind_W > bp && i === breakpoints.length - 1)
                    return Infinity;
            }
            return false;
        };

        var $sliderWrappers = $(wrapper);

        $sliderWrappers.each(function () {
            var $sliderWrapp = $(this),
                $sliderInit = get_Slider($sliderWrapp),
                $sliderCopy = $sliderWrapp.clone(),
                bp = get_current_bp();

            if (!$sliderInit.length) return false;

            var start_Rev = function ($sliderInit, bp) {
                var wind_W = window.innerWidth,
                    rev_settings_obj = {},
                    rev_screen_obj = {},
                    set_rev_obj = {};

                if (fullscreen_BP) {
                    var full_width = (wind_W >= fullscreen_BP) ? 'off' : 'on',
                        full_screen = (wind_W >= fullscreen_BP) ? 'on' : 'off';

                    rev_screen_obj = {
                        fullWidth: full_width,
                        fullScreen: full_screen
                    };
                }

                if (bp_arr.length) {
                    for (var i = 0; i < bp_arr.length; i++) {
                        var this_obj = bp_arr[i];

                        if (this_obj.bp && this_obj.bp.length === 2 && this_obj.bp[0] < this_obj.bp[1]) {
                            var from = this_obj.bp[0],
                                to = this_obj.bp[1];

                            if (from <= bp && to >= bp) {
                                for (var key in this_obj) {
                                    if (key !== 'bp')
                                        rev_settings_obj[key] = this_obj[key];
                                }
                            }
                        }
                    }
                }

                $.extend(set_rev_obj, rev_obj, rev_settings_obj, rev_screen_obj);

                $($sliderInit).show().revolution(set_rev_obj);

                $(options.functions).each(function () {
                    this.call($sliderInit);
                });
            };

            start_Rev($sliderInit, bp);

            var restart_Rev = function (current_bp) {
                if (!$($sliderInit).hasClass('revslider-initialised')) return;
                bp = current_bp || 0;
                $sliderInit.revkill();
                $sliderWrapp.replaceWith($sliderCopy);
                $sliderWrapp = $sliderCopy;
                $sliderCopy = $sliderWrapp.clone();
                $sliderInit = get_Slider($sliderWrapp);
                start_Rev($sliderInit, bp);
            };

            function endResize(func) {
                var windWidth = window.innerWidth,
                    interval;

                interval = setInterval(function () {
                    var windWidthInterval = window.innerWidth;
                    if (windWidth === windWidthInterval) {
                        setTimeout(function () {
                            func();
                        }, 200);
                    }
                    clearInterval(interval);
                }, 100);
            };

            $(window).on('resize', function () {
                endResize(function () {
                    var current_bp = get_current_bp();
                    if (current_bp !== bp)
                        restart_Rev(current_bp);
                })
            });
        });
    };

    var delay = this.data('speed'),
        fullscreen = this.attr('data-fullscreen') == 'false' ? false : 768,
        width = this.attr('data-width'),
        height = this.attr('data-height');

    if (this.hasClass('revolution-default')) {
        this.resizeRevolution(
            {
                slider: '.tp-banner',
                breakpoints: [414, 767, 1025],
                fullscreen_BP: fullscreen,
                functions: [
                    click_to_play_video,
                    autoplay_video
                ]
            },
            {
                fullScreenOffsetContainer: "header",
                navigationArrows: "true",
                startwidth: width || 1920,
                startheight: height || 800
            },
            [
                {
                    bp: [0, 768],
                    startheight: height || 1200
                }
            ],
            delay
        );
    } else {
        this.resizeRevolution(
            {
                slider: '.tp-banner',
                breakpoints: [414, 767, 1025],
                fullscreen_BP: 768,
                functions: [
                    click_to_play_video,
                    autoplay_video
                ]
            },
            {
                fullScreenOffsetContainer: "header-static"
            },
            [
                {
                    bp: [0, 768],
                    startheight: 1300
                },
                {
                    bp: [0, 1025],
                    fullScreenOffsetContainer: "header"
                }
            ],
            delay
        );
    }
}

/* products options */
function initProductOptions() {
    $('body').on('click', '.productitem-option1-js a', function (e) {
        var $this = $(this)
        optionsHandler(e, $this);
        var val = $this.parent().attr("data-tag") + '-js';
        var _parent = $this.closest('.product_inside_info');
        val = _parent.optionsSetParams(val, '.productitem-option2-js');
        _parent.optionsSetParams(val, '.productitem-option3-js');
    })
    $('body').on('click', '.productitem-option2-js a', function (e) {
        var $this = $(this)
        optionsHandler(e, $this);
        var val = $this.parent().attr("data-tag") + '-js';
        var _parent = $this.closest('.product_inside_info');
        _parent.optionsSetParams(val, '.productitem-option3-js');
    });
    $('body').on('click', '.productitem-option3-js a', function (e) {
        optionsHandler(e, $(this));
    });
}

function optionsHandler(e, $this) {
    e.preventDefault();
    setNewData($this);
}

$.fn.optionsSetParams = function (val, str) {
    var _opt = this.find(str);
    if (_opt.length == 0) return false;
    _opt.show().find('li').each(function () {
        $(this).hide().removeClass('active')
    });
    if (_opt.find('[data-current-option="' + val + '"]').length == 0) return false;
    _opt.find('[data-current-option="' + val + '"]').show().first().addClass('active');
    return _opt.find('.active').find('a').parent().attr("data-tag") + '-js';
}

function setNewData($this) {
    var _parent = $this.parent();
    _parent.parent().find(".active").removeClass('active');
    _parent.addClass('active');

    var availability = Boolean(_parent.data('variant_availability'));
    var $pr_parent = $this.closest('.product');

    $pr_parent.find('input').val(_parent.attr('data-var_id'));

    var img_src = _parent.attr('data-img');
    if (img_src != '') $pr_parent.find('img').first().attr('src', img_src);

    var $btn = $pr_parent.find('.btn-product_addtocart');
    $btn.attr('href', '/cart/add.js?quantity=1&id=' + _parent.attr('data-var_id'));
    availability ? $btn.html(addtocart_text).removeClass('disable') : $btn.html(unavailable_text).addClass('disable');

    var mainprice = $pr_parent.find('.price span:first-child');
    var oldprice = $pr_parent.find('.old-price');
    mainprice.html(Shopify.formatMoney(_parent.attr('data-price'), money_format));
    var compprice = String(_parent.attr('data-compprice'));
    oldprice.html(Shopify.formatMoney(compprice, money_format));
    if (!compprice) {
        !oldprice.hasClass('hide') && oldprice.addClass('hide');
        mainprice.hasClass('new-price') && mainprice.removeClass('new-price');
    } else {
        oldprice.hasClass('hide') && oldprice.removeClass('hide');
        !mainprice.hasClass('new-price') && mainprice.addClass('new-price');
    }
    $('body').trigger('refreshCurrency');
}

if ($('.autoscroll_yes').length) {
    $(window).scroll(function () {
        autoscrollhandler();
    });
}

function autoscrollhandler() {
    var _as = $('.autoscroll');
    if (_as.length == 0) return false;
    var contY = parseInt(_as.parent().offset().top);
    var wY = getWindowHeight() + getWindowTopY();
    if (contY <= wY) {
        _as.removeClass('autoscroll').trigger('click');
    }
}

function getWindowHeight() {
    return window.innerHeight;
}

function getWindowTopY() {
    return window.pageYOffset || document.documentElement.scrollTop;
}

jQuery(function ($) {

    jQuery('.show-more').on('click', function (e) {
        e.preventDefault();
        var target = jQuery(this).attr('aria-controls');
        $('#' + target).slideToggle('slow', function () {
            if ($('#' + target).css('display') !== 'none') {
                jQuery('.show-more').html('Read Less');
            } else {
                jQuery('.show-more').html('Read More');
            }
        });
    })

    setSlickGallery($('.section__explore_popular .subcategory-listing'), 3, 3, 3, 2, 1, 'carousel');

    $('.cart .dropdown-toggle').on('click', function (e) {
        e.preventDefault();
        Rebuy.SmartCart.visible = true;
    });

    var obj = $('.desktop-header .box-info');
    if (obj.length) {
        var rowObjHeight = obj.closest('.container').innerHeight();
        if (rowObjHeight === null) {
            rowObjHeight = obj.closest('.container-fluid').innerHeight();
        }
        ;
        obj.innerHeight(rowObjHeight);
    }
    $(window).on('load', function () {
        $('body').addClass('loaded');
    });

    $('.product-images-carousel-vertical').find('#smallGallery').slick('unslick');
    $('.wrapper__member').each(function () {
        $(this).on('click', '.wrapper__header', function (e) {
            e.preventDefault();
            $(this).next().toggleClass('visible');
        })
    });

    $('.nav__main .menu__item-sibling').each(function () {
        $(this).hover(function () {
            bcLog('hover');
            $(this).siblings().removeClass('selected');
            $(this).addClass('selected');
        })
    });

    var $menu = $('.stuck-nav .menu__dropdown');

    $(document).mouseup(function (e) {
        if (!$menu.is(e.target) && $menu.has(e.target).length === 0) {
            $menu.removeClass('visible');
        }
    });

    $('.stuck-nav .btn-toggle-menu').click(function () {
        $('.stuck-nav .menu__dropdown').toggleClass('visible');
    });

    $('.form__search input[type="text"]').attr('placeholder', 'Seek and you shall find');

    $('.stuck-nav .icon__search').click(function () {
        $('.mobile-header .container-fluid.top-line').toggleClass('visible');
        $('.stuck-nav .wrapper__middle').toggleClass('visible');
    });


    $('.tt-tabs__head li').each(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        }
    });

    $('.tt-tabs__body .tt__tabs__body__content').each(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).find('.tt-tabs__content').css('display', 'none');
        }
    });


    $('.tt-tabs__head li:first-of-type').addClass('active');
    $('.tt-tabs__body .tt__tabs__body__content:first-of-type').addClass('active');
    $('.tt-tabs__body .tt__tabs__body__content:first-of-type .tt-tabs__content').show();

    $('.mainmenu-mobile ul').append('<li><a href="tel:18333201187">1 (833) 320-1187</a></li>');

    var pagesRemoveDetailsTab = ['gesso-white', 'transfpaper-sdi', 'drytac-roller-laminators', 'dust-removal-system-roller', 'easywrappe-125', 'solvent-glossy-photo-paper', 'solvent-satin-photo-paper', 'photo-peel-sul', 'pre-notched-stretcher-bars', 'quartz', 'radiance-hd-metal', 'rdy-hang-frame', 'sample-packs', 'stretchrelief', 'timeless-roller-kit', 'timeless-varnish', 'trial-kits', 'insignia-scrim-vinyl'];
    var pagesRemoveResourcesTab = ['transfpaper-sdi', 'dust-removal-system-roller', 'solvent-glossy-photo-paper', 'solvent-satin-photo-paper', 'sample-packs', 'stretcher-bar-sticks', 'timeless-roller-kit', 'trial-kits', 'insignia-scrim-vinyl'];

    var pageHandler = function (page, item) {
        if (document.querySelector('.' + page)) {
            var elem = document.querySelector('.' + page + ' .tt-tabs .tt-tabs__head li:nth-of-type(' + item + ')');
            if (elem) {
                elem.style.display = 'none';
            }
        }
    }

    pagesRemoveDetailsTab.forEach(function (page) {
        pageHandler(page, 2);
    });

    pagesRemoveResourcesTab.forEach(function (page) {
        pageHandler(page, 3);
    });

    var productHighlights = document.querySelector('.product__highlights ul');

    if (productHighlights && productHighlights.children.length == 0) {
        document.querySelector('.product__highlights').style.display = 'none';
    }

});


function handleMessage(event) {
    var accepted_origin = 'https://blog.breathingcolor.com';
    if (event.origin == accepted_origin) {
        if (event.data['task'] == 'scroll_top') {
            window.scrollTo(0, 0);
        }
        if (event.data['task'] == 'resize') {
            $('.customimage iframe').css({'height': event.data['height'] + 'px'});
        }
        // you can have more tasks
    } else {
        //console.error('Unknown origin', event.origin);
    }
}

window.onload = function () {
    window.addEventListener("message", handleMessage, false);
}

function bcLog(entry) {
    console.debug(entry);
}

function itemPriceBC(item) {
    //console.debug(item);
    return (item.price / 100).toFixed(2);
    const filtered = window.BOLD.common.cartDoctor.cart.items.filter((v) => v.id == item.id);
    if (filtered.length === 0) {
        return (item.price / 100).toFixed(2);
    }
    return (filtered[0].price / 100).toFixed(2)
}

function compareAtPriceBC(item) {
    //console.debug(item);
    const comparePrice = window.Rebuy.SmartCart.compareAtPrice(item);
    //console.debug('comparePrice: ', comparePrice);
    if (comparePrice !== item.price) return comparePrice;
    return '';
}

function subtotalBC() {
    return '$' + (window.BOLD.common.cartDoctor.cart.total_price / 100).toFixed(2);
}

document.addEventListener('rebuy:smartcart.init', function (event) {
    console.log('rebuy:smartcart.init event', event.detail);
    initTierDiscount();
});

document.addEventListener('rebuy:smartcart.ready', function (event) {
    console.log('rebuy:smartcart.ready event', event.detail);
    /*for (var i = 1; i <= 500; i = i + 50) {
        setTimeout(function () {
            $($('.rebuy-cart__progress-step-label')[0]).html('15%');
            $($('.rebuy-cart__progress-step-label')[1]).html('20%');
        }, i);
    }*/
    smartcartShow();
});

function smartcartShow() {
    var promoCode = getCookie('promoCode');
    if (promoCode === 'PROMO202306') {
        $('.rebuy-cart__flyout-content.has-items .promo-bar-container').remove();
        var $promo2 = $('.promo-bar-container').clone();
        $('.rebuy-cart__flyout-content.has-items').prepend($promo2);
        /*for (var i = 1; i <= 1000; i = i + 100) {
            setTimeout(function () {
                if ($('.rebuy-cart__progress-bar-container').length != 0) {
                    $('.rebuy-cart__progress-bar-container').show();
                }
            }, i);
        }*/
    }
}

document.addEventListener('rebuy:smartcart.show', function (event) {

    console.log('rebuy:smartcart.show event', event.detail);
    initTierDiscount();


    setTimeout(function () {
        $($('.rebuy-cart__progress-step-label')[0]).html('15%');
        $($('.rebuy-cart__progress-step-label')[1]).html('20%');
        smartcartShow();

        // let total = 0;
        // event.detail.smartcart.cart.items.forEach(function (el, i) {
        //     console.log(el);
        //     var id = el.variant_id;
        //     console.log(id);
        //     console.log(BOLD.common.Shopify.variants[id]);
        //     if (typeof BOLD.common.Shopify.variants[id] !== 'undefined') {
        //         BOLD.common.Shopify.variants[id].variant_id = id;
        //         var t = window.applyCSPDiscounts(BOLD.common.Shopify.variants[id]);
        //         console.log(t);
        //         console.log('el price:');
        //         console.debug(el);
        //         if (t) {
        //             total += t.price * el.quantity;
        //             $('.product-' + id + ' .rebuy-money:not(.compare-at)').html(BOLD.common.Shopify.formatMoney(t.price));
        //         } else {
        //             total += el.price * el.quantity;
        //         }
        //     } else {
        //         total += el.price * el.quantity;
        //     }
        // });
        // console.debug(total);
        // $('.rebuy-cart__flyout-subtotal-amount').html(BOLD.common.Shopify.formatMoney(total));
        console.log('rebuy:smartcart.show after event', event.detail);


        customCartRefresh();
    }, 250);

    showTieredBonusBar();

});

function customCartRefresh() {


    setTimeout(function () {
        jQuery.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function (cart) {
                $('.badge.badge-cart').html(cart.items.reduce((i, el) => i + el.quantity, 0));
                $('[data-key]').each((i, w) => {
                    $(w).removeAttr('data-key');
                    $(w).removeAttr('data-index');
                })

                cart.items.forEach(function (el, i) {
                    const p = $($('.rebuy-cart__flyout-body [data-id="' + el.id + '"]:not([data-key])')[0]);

                    if (p.attr('data-key')) {
                        return;
                    }
                    p.attr('data-index', i)
                    p.attr('data-key', el.key)
                });
                var total = 0;
                cart.items.forEach(function (el, i) {
                    console.log(el.key);
                    const p = $('[data-key="' + el.key + '"]');
                    console.log(i, el);
                    let price = el.final_price;
                    if (el.discounted_price) {
                        price = el.discounted_price;
                        $('.rebuy-money:not(.compare-at)', p).html(BOLD.common.Shopify.formatMoney(el.discounted_price));
                    } else {
                        $('.rebuy-money:not(.compare-at)', p).html(BOLD.common.Shopify.formatMoney(el.final_price));
                    }
                    //$('.rebuy-money.compare-at').hide();
                    //console.log('original_price: ', el.original_price);
                    //console.log('discounted_price: ', price);
                    if (price != el.original_price) {
                        $('.rebuy-money.compare-at', p).html(BOLD.common.Shopify.formatMoney(el.original_price));
                    } else {
                        if (BOLD.common.Shopify.formatMoney(price) != $('.rebuy-money.compare-at', p).html()) {

                        } else {
                            $('.rebuy-money.compare-at', p).hide();
                        }
                    }
                    total += el.original_line_price;
                });
                $('.total-without-discounts').remove();
                if ($('.rebuy-cart__flyout-subtotal-amount').text() != BOLD.common.Shopify.formatMoney(total)) {
                    $('.rebuy-cart__flyout-subtotal-amount').after('<span class="total-without-discounts">' + BOLD.common.Shopify.formatMoney(total) + '</span>');
                }
            }
        });
    }, 100);
}

document.addEventListener('rebuy:cart.change', function (event) {
    customCartRefresh();

    initTierDiscount();
});

document.addEventListener('rebuy:smartcart.hide', function (event) {
    console.log('rebuy:smartcart.hide event', event.detail);
});

document.addEventListener('rebuy.refresh', function (event) {
    console.log('rebuy.refresh event', event.detail);

    customCartRefresh();
});

document.addEventListener('rebuy.add', function (event) {
    console.log('rebuy.add event', event.detail);
    //BOLD.common.eventEmitter.emit('BOLD_COMMON_products_loaded', event.detail.product.id);

    if (event.detail.widget && event.detail.widget.id == "61661") {
        jQuery.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function (cart) {
                //addPromo(31563371085920, cart, '61661');
            }
        });
    }

    jQuery.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function (cart) {
            console.log('Cart: ');
            console.debug(cart);
            //BOLD.common.eventEmitter.emit("BOLD_COMMON_refresh", cart);
            if (window.BOLD && BOLD.common && BOLD.common.cartDoctor && typeof BOLD.common.cartDoctor.fix === 'function') {
                cart = BOLD.common.cartDoctor.fix(cart);
            }
            console.debug(cart);

            if (window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
                BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', cart);
            }

            // setTimeout(function() {
            //     Rebuy.SmartCart.hide();
            //     setTimeout(function() {
            //         Rebuy.SmartCart.show();
            //     }, 50);
            // }, 450);
        }
    });

});

if (window.BOLD && window.BOLD.common && window.BOLD.common.eventEmitter) {
    window.BOLD.common.eventEmitter.on('BOLD_COMMON_cart_loaded', function (cart) {
        //console.log('BOLD_COMMON_cart_loaded event', cart);
        //console.log(cart);
    })
}

document.addEventListener('BOLD_COMMON_refresh', function (event) {
    //console.log('BOLD_COMMON_refresh event', event.detail);

});


const a = function () {
    function t(t, e) {
        var n = []
            , r = !0
            , i = !1
            , o = void 0;
        try {
            for (var a, u = t[Symbol.iterator](); !(r = (a = u.next()).done) && (n.push(a.value),
            !e || n.length !== e); r = !0)
                ;
        } catch (t) {
            i = !0,
                o = t
        } finally {
            try {
                !r && u.return && u.return()
            } finally {
                if (i)
                    throw o
            }
        }
        return n
    }

    return function (e, n) {
        if (Array.isArray(e))
            return e;
        if (Symbol.iterator in Object(e))
            return t(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance")
    }
}()
    , u = function () {
    function t(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            r.enumerable = r.enumerable || !1,
                r.configurable = !0,
            "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r)
        }
    }

    return function (e, n, r) {
        return n && t(e.prototype, n),
        r && t(e, r),
            e
    }
}();

window.applyCSPDiscounts = function (t) {
    if (!t) {
        return;
    }
    if (t.csp_applied_discount) {
        return t;
    }
    var e = this
        , n = function (t) {
        var e = window.BOLD.common.Shopify.metafields.bold_csp_defaults;
        if (e && e[t]) {
            return "%," + e[t] + ",,1,,0"
        }
    }
        , r = function (t, e, n) {
        if (n) {
            var r = t + "~1"
                , i = e;
            do {
                r = t + "~" + i,
                    i--
            } while (void 0 === n[r] && i > 0);
            return n[r]
        }
    };
    t.csp_applied_discount = !1;
    if (!BOLD.common.Shopify.variants[t.variant_id]) {
        return;
    }
    var i = BOLD.common.Shopify.variants[t.variant_id].csp_metafield
        , o = function (t) {
        var e = BOLD.common.Shopify.customer.tags;
        void 0 === e && (e = window.shappify_customer_tags),
        e && 0 !== e.length || (e = ["default"]);
        for (var r = void 0, i = 0; i < e.length; i += 1)
            if (void 0 !== t && void 0 !== t[e[i] + "~1"]) {
                r = e[i];
                break
            }
        return void 0 === r && (r = e[0],
        void 0 === n(r) && (r = "default")),
            r
    }(i)
        , u = function (t, n, r) {
        var i = r && r[n + "~1"] ? r[n + "~1"].split(",") : []
            , o = a(i, 6)
            , u = o[5]
            , c = void 0 === u ? "0" : u;
        return 1;
    }(t, o, i)
        , c = function (t, e, i) {
        return r(t, e, i) || n(t)
    }(o, u, i);
    return function (t, n) {
        if (!n)
            return t;
        var r = n.split(",")
            , i = a(r, 3)
            , o = i[0]
            , u = i[1]
            , c = i[2]
            , s = t.line_price
            , f = t.price;
        switch (o) {
            case "$":
                f = 100 * u;
                break;
            case "%":
                f *= u;
                break;
            case "-":
                f -= 100 * u
        }
        if (void 0 !== c && "" !== c) {
            var l = 1 === c.length ? "0" + c : c;
            f = parseInt(parseInt(f).toString().slice(0, -2) + l)
        }
        if (!isNaN(f) && f < t.price) {
            t.price = f;
            t.csp_applied_discount = !0
        }
        return t
    }(t, c)
};

window.itemAttrClass = function (str) {
    return 'attr-' + convertToSlug(str);
}

function convertToSlug(Text) {
    return Text.toLowerCase()
        .replace(/[^\w ]+/g, '')
        .replace(/ +/g, '-');
}

function addPromo(variant_id, cart, bonusType) {
    jQuery.ajax({
        type: 'GET',
        url: '/discount/BONUSROLLER',
        success: function () {

            if (cart && cart.items.length > 0) {
                let found = false;
                for (var i = 0; i < cart.items.length; i++) {
                    const item = cart.items[i];
                    const isBonus = checkIsBonus(cart.items[i]);

                    if (item && item.id == variant_id && isBonus) {
                        found = true;
                        break;
                    }
                }
                if (found === false) {
                    const data = {
                        "id": variant_id,
                        "quantity": 1,
                        properties: {
                            '_type': 'Bonus',
                            '_bonus': bonusType
                        }
                    };
                    jQuery.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: data,
                        dataType: 'json',
                        success: function (cart) {
                            console.debug('Success adding bonus promo');
                        }
                    });
                }

            }
        }
    });

}

function checkIsBonus(item) {
    return (item.properties != null &&
        (item.properties['_type'] === 'Bonus'));
}

let discount_type = '';
let discount_price = '';

async function loadBundle() {
    const response = await fetch('https://shopbiz.wearevisum.com/api/v1/bundles?product_id=' + meta.product.id);
    bundle = await response.json();

    bcLog(bundle);

    const element = document.getElementById("bundle_compose");
    const container = document.createElement("div");

    bundle.forEach((v) => {
        discount_type = v.discount_type;
        discount_price = v.discount_price;

        const child_container = document.createElement("div");

        const h3 = document.createElement("h4");
        const node = document.createTextNode(v.name);
        h3.appendChild(node);

        const para = document.createElement("p");
        const nodeDesc = document.createTextNode(v.description);
        para.appendChild(nodeDesc);

        const select = document.createElement("select");
        select.setAttribute("name", "bundle_products[" + v.id + "]");
        select.setAttribute("class", "bundle_select");

        if (v.has_empty_option === 1) {
            const option = document.createElement("option");
            option.setAttribute("value", "");
            option.setAttribute("data-price", 0.0);
            const nodeDesc = document.createTextNode("No " + v.name);
            option.appendChild(nodeDesc);

            select.appendChild(option);
        }

        v.expanded_products.forEach((p) => {
            const option = document.createElement("option");
            option.setAttribute("value", p.shopify_id);
            option.setAttribute("data-price", p.price);
            const nodeDesc = document.createTextNode(p.title + (p.price > 0 ? ' ($' + p.price + ')' : ''));
            option.appendChild(nodeDesc);

            select.appendChild(option);
        });
        select.addEventListener('change', handleBundleProductChange)

        child_container.appendChild(h3);
        child_container.appendChild(para);
        child_container.appendChild(select);

        container.appendChild(child_container);
    });

    const button = document.createElement("button");
    button.setAttribute("id", "btn_add_bundle");
    button.setAttribute("class", "btn");
    const nodeDesc = document.createTextNode("Add to Cart");
    button.appendChild(nodeDesc);
    button.addEventListener("click", handleBundleClick)

    container.appendChild(button);

    while (element.firstChild) {
        element.firstChild.remove();
    }
    element.appendChild(container);

    Array.from(document.getElementsByClassName('bundle_select')).forEach((select) => {
        if (select.value !== "") {
            const changeEvent = new Event('change');
            select.dispatchEvent(changeEvent);
        }
    });

    var total = recaculateBundlePrice();
    $('.product-info .price.price-bc').html('$' + total.toFixed(2));

    // logs [{ name: 'Joker'}, { name: 'Batman' }]
}

async function handleBundleClick() {
    bcLog('handleBundleClick');
    document.getElementById('bundle_compose').classList.add('loading');

    const components = [];
    const properties = {};
    Array.from(document.querySelectorAll('#bundle_compose select')).forEach((v, i) => {
        if (v.value !== '') {
            components.push({
                id: v.value,
                qty: 1
            });
            const index = i + 1;
            const option_text = v.options[v.selectedIndex].innerText.replace(/ \([0-9\.,\$]+\)/, '');
            properties[index + '. ' + option_text] = '1';
            properties['_id' + index] = v.value;
        }
    });
    properties['_bundle_id'] = meta.product.id;
    bcLog(components);

    const data = {
        'bundle_id': meta.product.id,
        'components': components
    };
    const response = await (fetch('https://shopbiz.wearevisum.com/api/v1/bundles', {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: "POST",
        body: JSON.stringify(data)
    }).catch(handleError));

    try {
        const ret = await response.json();
        bcLog(ret);
        if (typeof ret !== 'undefined'
            && typeof ret.variants[0].shopify_id !== 'undefined') {
            bcLog(ret.variants[0].shopify_id);
            const data = {
                id: ret.variants[0].shopify_id,
                qty: 1,
                properties: properties
            };
            addToCart(data);
        }

    } catch (e) {
        console.error(e);
    }

    document.getElementById('bundle_compose').classList.remove('loading');
}

function handleBundleProductChange(e) {
    const elem = e.target;
    const idBundle = elem.name.replace('bundle_products[', '').replace(']', '');
    console.log("idBundle: " + idBundle);
    const idSel = elem.options[elem.selectedIndex].value;
    bcLog(bundle);
    if (bundle.filter(v => v.id === parseInt(idBundle)).length === 0) {
        return;
    }
    const selectedProduct = bundle.filter(v => v.id === parseInt(idBundle))[0].expanded_products.filter((v) => v.shopify_id == idSel)[0];
    bcLog(selectedProduct);


    const bundleDesc = document.getElementsByClassName('comp_desc_' + idBundle);
    let child_container;
    if (bundleDesc.length === 0) {
        child_container = document.createElement("div");
        child_container.classList.add('comp_desc_' + idBundle);
        child_container.classList.add('clearfix');
        child_container.style = "min-height: 120px;";

    } else {
        child_container = document.getElementsByClassName('comp_desc_' + idBundle)[0];
    }

    child_container.innerHTML = '';

    const img = document.createElement("img");
    img.src = selectedProduct.img;
    img.style = "float:left;margin-left:5px;width:120px;";
    const node = document.createTextNode(selectedProduct.title);
    child_container.appendChild(img);
    child_container.appendChild(node);

    if (bundleDesc.length === 0) {
        elem.parentNode.insertBefore(child_container, elem.nextSibling);
    }


    const total = recaculateBundlePrice();
    const price = Intl.NumberFormat(Shopify.locale, {
        style: 'currency',
        currency: Shopify.currency.active
    }).format(total);
    bcLog(price);
    document.querySelector('.price.price-bc').innerText = price;
}

function recaculateBundlePrice() {
    let total = 0;
    Array.from(document.getElementsByClassName('bundle_select')).forEach((v) => {
        const price = v.options[v.selectedIndex].getAttribute('data-price');
        total += parseFloat(price);
    });

    return getDiscountedPrice(total);
}

function getDiscountedPrice(price) {

    console.log(discount_type);
    if (discount_type === 'P') {
        console.log(discount_price);
        return price - price * discount_price / 100;
    }
    if (discount_type === 'F') {
        console.log(discount_price);
        return price - discount_price;
    }

    return price;
}

const handleError = function (err) {
    console.warn(err);
    return new Response(JSON.stringify({
        code: 400,
        message: 'Stupid network Error'
    }));
};

async function addToCart(data) {
    const response = await (fetch('/cart/add.js ', {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: "POST",
        body: JSON.stringify(data)
    }).catch(handleError));
    const ret = await response.json();

    bcLog(ret);

    const response2 = await (fetch('/cart.js ', {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: "POST",
        body: JSON.stringify(data)
    }).catch(handleError));
    const ret2 = await response2.json();

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));

    document.dispatchEvent(new CustomEvent('theme:cart:change', {
        detail: {
            cart: ret2,
        },
        bubbles: true,
    }));
    return ret;
}

function showTieredBonusBar() {
    var promoCode = getCookie('promoCode');
    if (typeof promoCode === 'undefined' || promoCode === '') {
        promoCode = localStorage.getItem("promoCode");
    }

    if (promoCode === 'PROMO202306') {
        showTieredBonus();
    }
}

function initTieredBonus() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('promoCode')) {
        setCookie('promoCode', urlParams.get('promoCode'));
        localStorage.setItem("promoCode", urlParams.get('promoCode'));
    }

    showTieredBonusBar();
}

function buildPromoSlider() {
    $('.promo__slides').not('.slick-initialized').slick({
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "responsive": [
            {
                "breakpoint": 1024,
                "settings": {"slidesToShow": 1, "slidesToScroll": 1}
            },
            {
                "breakpoint": 600,
                "settings": {"slidesToShow": 1, "slidesToScroll": 1}
            },
            {
                "breakpoint": 480,
                "settings": {"slidesToShow": 1, "slidesToScroll": 1}
            }],
        "centerMode": false,
        "infinite": true,
        "rtl": false,
        "autoplay": false,
        "autoplaySpeed": 5000,
        "adaptiveHeight": true,
        "arrows": true,
        "dots": false
    });
    $('.promo__slides').show();
}


function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

async function showTieredBonus() {


    if ($('#promo-bar').length == 0) {
        $('body').append('<div id="promo-bar"></div>');
    }


    let maxRules = [0, 450];
    let promoBonuses = ['6% off', '9% off'];

    /*let maxRules = [0];
    let promoBonuses = ['20% off'];*/

    const maxValue = Math.max(...maxRules);

    const cartContents = await fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => {
            return data
        });

    // checkTieredStatus(cartContents);

    const excluded = [];
    // 42287317582070, 44279112368374, 44279112401142, 44279112433910, 44279112466678, 44279112499446, 44279112532214

    const excludedTotal = cartContents.items.filter(v => excluded.includes(v.variant_id)).reduce((total, v) => total + v.final_line_price, 0) / 100;

    let currentCartValue = cartContents.original_total_price / 100 - excludedTotal;
    console.log('currentCartValue: ' + currentCartValue);

    /*if ($('.product-subtotal .shopify-Price-amount.amount').length > 0) {
        cartContents.items.forEach((el) => {
            let priceHtml1 = '$' + (el.line_price / 100).toFixed(2) + '';
            let priceHtml2 = '$' + (el.final_price / 100).toFixed(2) + '';
            if (el.original_line_price !== el.line_price) {
                priceHtml1 = '<span style="text-decoration: line-through;">$' +
                    (el.original_line_price / 100).toFixed(2) + '</span> ' + '$' + (el.line_price / 100).toFixed(2) + '';
            }


            //console.log(priceHtml1);
            $('.cart_item_' + el.id + ' .product-subtotal .shopify-Price-amount.amount').html(priceHtml1);
            $('.cart_item_' + el.id + ' .product-price .shopify-Price-amount.amount').html(priceHtml2);

            if (typeof el.line_level_discount_allocations !== 'undefined' && el.line_level_discount_allocations.length > 0) {
                $('.cart_item_' + el.id + ' .cart-drawer__item-discount.text-small').html(el.line_level_discount_allocations[0].discount_application.title);
            }
        });

        if ($('.total_discount').length > 0) {
            $('.total_discount').remove();
        }
        if (cartContents.total_discount && $('.total_discount').length === 0) {
            const discount = '$' + (cartContents.total_discount / 100).toFixed(2) + '';
            jQuery('.cart_totals_column .cart_totals h2').after('<div style="text-align:right"><div class="total_discount">YOU SAVED: ' + discount + '</div></div>');
        }
    }*/

    let closestValue = 0;
    let closestIndex = maxRules.length - 2;
    if (tieredTag == 'Bronze' || tieredTag == 'Silver' || tieredTag == 'Gold') {
        currentCartValue = maxRules[maxRules.length - 1];
    }
    for (var i = 0; i < maxRules.length; i++) {
        if (currentCartValue >= maxRules[i]) {
            closestValue = maxRules[i];
            closestIndex = i;
        }
    }
    if (closestIndex === maxRules.length - 1) {
        closestIndex = maxRules.length - 2;
    }

    closestValue = maxRules[closestIndex + 1];

    // vsmDebug('adding promo');
    const diff = (closestValue - currentCartValue).toFixed(2);
    const percent = (currentCartValue / maxValue * 100) < 100 ? (currentCartValue / maxValue * 100) : 100;
    //
    const diffFormatted = parseFloat(diff).toLocaleString();
    console.log('diffFormatted' + diffFormatted);
    let diffText = 'YOU’RE $' + diffFormatted + ' FROM MORE SAVINGS';
    if (diff <= 0 && currentCartValue > 0) {
        diffText = 'YOU HAVE UNLOCKED ALL SAVINGS';
        //$('#nova-cart').addClass('has-promo');
    } else {
        $('#promo-bar').removeClass('has-promo');
    }

    var html = '<div class="break"></div><div class="promo-bar-container"><div class="promo-bar-text" data-value="' + percent + '">' + diffText + '</div>\n';
    for (var i = 0; i < maxRules.length; i++) {
        var percentage = maxRules[i] / maxValue * 100;
        var className = '';
        if (percentage <= percent) {
            className = ' checked';
        }
        if (currentCartValue >= maxRules[i] && i < maxRules.length - 1 && currentCartValue < maxRules[i + 1]) {
            className += ' nearest';
        }
        if (i === maxRules.length - 1 && currentCartValue >= maxRules[i]) {
            className += ' nearest';
        }
        html += '        <div class="progress promo-bar border-blue ' + className + '" style="width: ' + percentage + '%" max="' + percentage + '" value="' + Math.min(percent, percentage) + '" data-bonus="' + promoBonuses[i] + '"><span class="progress-val" style="width: ' + Math.min(percent, percentage) + '%"></span></div>\n';
        //html += '        <progress class="promo-bar border-blue ' + className + '" max="' + percentage + '" value="' + Math.min(percent, percentage) + '" style="width:' + percentage + '%;" data-bonus="' + promoBonuses[i] + '"> ' + percent + '% </progress>\n';
    }
    html += '    </div>';

    $('#promo-bar .break').remove();
    $('#promo-bar .promo-bar-container').remove();
    $('#promo-bar').append(html);
    $('#promo-bar').addClass('with-promo');
    $('body').addClass('b-has-promo');
}


function buildCollectionFilters() {
    $('#filters_clear').on('click', function (e) {
        e.preventDefault();
        $('.filter__col:checked').map((i, v) => $(v).removeAttr('checked'));
        $('.filter__col').first().trigger('change');
    });

    $('#filter__product_type').on('change', function () {
        if ($(this).is(':checked')) {
            $('.filters__type').addClass('selected');
        } else {
            $('.filters__type').removeClass('selected');
        }
    });
    $('.filter__col').on('change', function () {
        applyCollectionFilters();
    });
}

function applyCollectionFilters() {
    let ff = [];
    $('.filters__type dd').map((i, el) => {
        const cl = Array.from($('.filter__col:checked', $(el)).map((i, v) => $(v).attr('id')));
        if (cl.length > 0)
            ff.push(cl);
    });


    $('.filtered-product').show();
    if (ff.length > 0) {
        $('#filters_clear').show();

        const prod = cartesian(...ff);
        console.log(prod);
        let class_str;
        if (!Array.isArray(prod[0])) {
            class_str = '.' + prod.join(',.');
        } else {
            class_str =
                prod.map((b) => {
                    return '.' + b.join('.');
                }).join(', ')
        }

        $('.filter__col').each((i, col) => {
            const li = $(col).closest('li');
            const id = $(col).attr('id');
            console.log(id);
            console.log(class_str.replaceAll(',', '.' + id));
            $('.counter', $(li)).html('(' + $('' + '.' + id + class_str.replaceAll(',', ',.' + id) + '').length + ')');
        })


        const selector = '.filtered-product:not(' + class_str + ')';
        console.log(selector);
        $(selector).hide();
    } else {
        $('#filters_clear').hide();
        $('.filter__col').each((i, col) => {
            const li = $(col).closest('li');
            const id = $(col).attr('id');

            $('.counter', $(li)).html('(' + $('.' + id).length + ')');
        })
    }

    const total = $('.filtered-product:visible').length;
    $('.filters__results').html(total + (total === 1 ? ' product' : ' products'));
}

function intersect(a, b) {
    var setA = new Set(a);
    var setB = new Set(b);
    var intersection = new Set([...setA].filter(x => setB.has(x)));
    return Array.from(intersection);
}

const cartesian =
    (...a) => a.reduce((a, b) => a.flatMap(d => b.map(e => [d, e].flat())));

function getPromoCode() {
    var promoCode = getCookie('promoCode');
    if (typeof promoCode === 'undefined' || promoCode === '') {
        promoCode = localStorage.getItem("promoCode");
    }

    return promoCode;
}

async function initTierDiscount() {
    const promoCode = getPromoCode();

    //if (promoCode === 'TEST_TIER01') 
    {


        const html = await getTieredBonus();
        if (html) {
            $('.rebuy-cart__flyout-body .break').remove();
            $('.rebuy-cart__flyout-body .promo-bar-container').remove();
            $('#rebuy-cart').addClass('with-promo');
            // $('body').addClass('b-has-promo');
            $('.rebuy-cart__flyout-body').prepend(html);
        }
    }
}


async function getTieredBonus() {

    console.log('tieredTag', tieredTag);
    if (tieredTag !== '' && getPromoCode() !== 'TESTSUMMER2024') {
        const titleText = `Your Loyalty Tier: ${tieredTag}`;
        let percentTier = '';
        switch (tieredTag) {
            case 'Gold':
                percentTier = '13';
                break;
            case 'Silver':
                percentTier = '9';
                break;
            case 'Bronze':
                percentTier = '6';
                break;
        }
        console.log('percentTier', percentTier);
        if (percentTier === '') {
            return;
        }
        const subTitleText = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_689_71)">
<path d="M15.7917 12.3207C15.3992 11.5024 13.9951 10.3665 12.6384 9.26903C11.8817 8.65735 11.1667 8.07903 10.7109 7.62321C10.5967 7.50821 10.4259 7.47153 10.2751 7.52571C9.99427 7.62739 9.82092 7.70571 9.68428 7.76653C9.47596 7.85985 9.40595 7.89153 9.1251 7.91985C9.00092 7.93235 8.88928 7.99903 8.8201 8.10235C8.23092 8.98317 7.62092 8.90817 7.21342 8.77153C7.08342 8.72821 7.0601 8.67235 7.0476 8.61903C6.9601 8.25321 7.39928 7.40153 7.96842 6.83235C9.3226 5.47735 10.0209 5.13817 11.4959 5.79735C13.1692 6.54567 14.8459 7.13153 14.8626 7.13735C15.0818 7.21317 15.3176 7.09817 15.3934 6.88067C15.4684 6.66317 15.3542 6.42567 15.1367 6.34985C15.1201 6.34403 13.4767 5.76985 11.8367 5.03567C9.92592 4.18149 8.87756 4.74399 7.38006 6.24235C6.81006 6.81235 6.03588 7.96567 6.23588 8.81153C6.3217 9.17153 6.57506 9.43821 6.9517 9.56235C7.89588 9.87403 8.75752 9.57567 9.3992 8.72403C9.6642 8.68321 9.80838 8.62321 10.025 8.52571C10.1033 8.49071 10.195 8.44989 10.3167 8.40071C10.7934 8.84821 11.4367 9.36903 12.1142 9.91653C13.3392 10.9074 14.7284 12.0307 15.0409 12.6807C15.1951 13.0015 15.0292 13.2107 14.9167 13.3065C14.7517 13.4482 14.5259 13.4932 14.4034 13.4074C14.2684 13.3149 14.0926 13.309 13.9534 13.3924C13.8134 13.4757 13.7351 13.6332 13.7526 13.7949C13.7809 14.0599 13.5384 14.2115 13.4334 14.264C13.1667 14.399 12.8884 14.3757 12.7842 14.279C12.6675 14.1707 12.5 14.139 12.3517 14.194C12.2034 14.2499 12.1 14.3865 12.085 14.5449C12.06 14.8182 11.8575 15.0807 11.5933 15.1832C11.4658 15.2315 11.2808 15.2607 11.115 15.109C11.0117 15.0157 10.8683 14.9798 10.7342 15.0123C10.5984 15.0456 10.4892 15.144 10.4417 15.2748C10.4259 15.3165 10.39 15.4165 10 15.4165C9.72252 15.4165 9.22334 15.229 8.9792 15.0673C8.6867 14.8748 6.85252 13.5065 5.26838 12.1798C5.04588 11.9923 4.66088 11.5906 4.32088 11.2356C4.0192 10.9206 3.74338 10.6348 3.6017 10.5148C3.4242 10.3648 3.1617 10.3873 3.0142 10.564C2.86588 10.7398 2.88752 11.0032 3.06338 11.1515C3.19256 11.2607 3.44256 11.5248 3.71838 11.8123C4.09006 12.2006 4.4742 12.6023 4.73256 12.819C6.28424 14.1182 8.14924 15.5207 8.52088 15.7648C8.82756 15.9665 9.48838 16.2498 10.0001 16.2498C10.4109 16.2498 10.7267 16.1556 10.9459 15.9715C11.2392 16.0857 11.5726 16.0865 11.8934 15.9615C12.2726 15.8148 12.5842 15.519 12.7609 15.1607C13.0892 15.2307 13.4651 15.1815 13.8067 15.0099C14.1409 14.8415 14.3825 14.584 14.5025 14.2832C14.8342 14.3007 15.1758 14.1832 15.4583 13.9407C15.9367 13.5315 16.0684 12.8949 15.7917 12.3207Z" fill="black"/>
<path d="M8.33343 5.41652H4.58343C4.35343 5.41652 4.16675 5.6032 4.16675 5.8332C4.16675 6.0632 4.35343 6.24988 4.58343 6.24988H8.33343C8.56343 6.24988 8.75011 6.0632 8.75011 5.8332C8.75011 5.6032 8.56343 5.41652 8.33343 5.41652Z" fill="black"/>
<path d="M17.0126 11.434C16.8834 11.2432 16.6251 11.1907 16.4342 11.3207L15.2159 12.139C15.0251 12.2673 14.9742 12.5265 15.1026 12.7173C15.1834 12.8365 15.3151 12.9015 15.4493 12.9015C15.5285 12.9015 15.6093 12.879 15.681 12.8307L16.8993 12.0124C17.0901 11.884 17.1409 11.6249 17.0126 11.434Z" fill="black"/>
<path d="M14.4257 13.4224C14.1274 13.1874 12.7932 11.8216 11.9682 10.9616C11.809 10.7949 11.5449 10.7891 11.379 10.9491C11.2123 11.1082 11.2073 11.3724 11.3665 11.5382C11.5807 11.7616 13.4698 13.7307 13.909 14.0774C13.9848 14.1374 14.0765 14.1666 14.1665 14.1666C14.289 14.1666 14.4115 14.1116 14.4948 14.0074C14.6374 13.8274 14.6066 13.5649 14.4257 13.4224Z" fill="black"/>
<path d="M12.7609 14.2582C12.2617 13.859 11.0075 12.5265 10.7242 12.2182C10.5675 12.0482 10.305 12.0382 10.135 12.1932C9.96583 12.349 9.95419 12.6132 10.11 12.7824C10.125 12.7982 11.6217 14.4141 12.24 14.9091C12.3167 14.9699 12.4092 14.9999 12.5 14.9999C12.6217 14.9999 12.7433 14.9457 12.8258 14.8441C12.9692 14.664 12.94 14.4015 12.7609 14.2582Z" fill="black"/>
<path d="M11.1025 15.0974C10.5083 14.5966 9.29253 13.3024 9.05503 13.0482C8.89753 12.8799 8.63335 12.8707 8.46585 13.0282C8.29753 13.1857 8.28917 13.449 8.44585 13.6174C8.78753 13.9832 9.95085 15.2166 10.565 15.7349C10.6433 15.8007 10.7383 15.8332 10.8333 15.8332C10.9517 15.8332 11.07 15.7824 11.1525 15.6849C11.3008 15.5082 11.2783 15.2457 11.1025 15.0974Z" fill="black"/>
<path d="M4.87 4.69738C4.15582 4.0207 1.3 3.80152 0.44168 3.7507C0.323359 3.74488 0.21418 3.78402 0.130859 3.8632C0.0475 3.94152 0 4.05152 0 4.16652V11.6665C0 11.8965 0.18668 12.0832 0.41668 12.0832H2.91668C3.09668 12.0832 3.25668 11.9674 3.3125 11.7957C3.37332 11.609 4.80918 7.20238 4.99832 5.0357C5.00918 4.90902 4.9625 4.78402 4.87 4.69738ZM2.6125 11.2499H0.83332V4.6132C2.1725 4.71902 3.6175 4.94902 4.1425 5.20402C3.92168 7.02902 2.9225 10.2715 2.6125 11.2499Z" fill="black"/>
<path d="M19.5832 4.58321C16.3115 4.58321 14.4965 5.42071 14.4207 5.45571C14.3124 5.50653 14.2315 5.60071 14.1982 5.71489C14.1649 5.82907 14.1815 5.95157 14.244 6.05321C14.759 6.88239 16.3715 11.4874 16.6815 12.6107C16.7315 12.7915 16.8957 12.9165 17.0832 12.9165H19.5832C19.8132 12.9165 19.9999 12.7298 19.9999 12.4998V4.99985C19.9999 4.76903 19.8132 4.58321 19.5832 4.58321ZM19.1666 12.0832H17.3949C16.9999 10.7965 15.8332 7.44153 15.1824 6.05489C15.8182 5.83907 17.1841 5.46821 19.1666 5.42157V12.0832Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_689_71">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg> Your discount rate is: <strong>${percentTier}%</strong>`;
        var html1 = '<div class="promo-bar-container bar-2024"><div class="promo-bar-wrapper"><div class="promo-bar-text" data-value="' + percentTier + '">' + titleText + '</div>\n';
        html1 += `<div class="promo-bar-sub-title">${subTitleText}</div>`;
        html1 += `    </div></div>`;

        return html1;
    }

    let maxRules = [0, 200, 400];
    let promoBonuses = ['', '3%', '6%'];

    /*let maxRules = [0];
    let promoBonuses = ['20%'];*/

    let titleText1 = '';
    /*if (getPromoCode() === 'TESTSUMMER2024') {
        maxRules = [0, 1, 450];
        promoBonuses = ['', '10%', '20%'];
        if (tieredTag === 'Gold') {
            titleText1 = `Your Loyalty Tier: ${tieredTag}`;
            promoBonuses[1] = '13%';
        }
    }*/

    const titleText = 'Shop More, Save More';

    const maxValue = Math.max(...maxRules);

    const cartContents = await fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => {
            return data
        });


    const excluded = [
        //Overstock //43512929452269, 43512929517805, 43512931221741, 43512936825069, 43512936890605, 43512936956141, 43512937251053, 43512938332397, 43512938430701, 43512931942637, 43512931975405, 43512927322349, 43512930042093, 43512929059053, 43512934990061, 43512935022829, 43512934564077, 43512928665837, 43512926372077, 44209059954925, 44209060020461, 44209060053229, 44209064476909, 44209064509677, 44209064542445, 44209064575213
    ];

    const excludedTotal = cartContents.items.filter(v => excluded.includes(v.variant_id)).reduce((total, v) => total + v.final_line_price, 0) / 100;

    const currentCartValue = cartContents.original_total_price / 100 - excludedTotal;
    console.log(currentCartValue);

    /*if ($('.product-subtotal .shopify-Price-amount.amount').length > 0) {
        cartContents.items.forEach((el) => {
            let priceHtml1 = '$' + (el.line_price / 100).toFixed(2) + '';
            let priceHtml2 = '$' + (el.final_price / 100).toFixed(2) + '';
            if (el.original_line_price !== el.line_price) {
                priceHtml1 = '<span style="text-decoration: line-through;">$' +
                    (el.original_line_price / 100).toFixed(2) + '</span> ' + '$' + (el.line_price / 100).toFixed(2) + '';
            }


            //console.log(priceHtml1);
            $('.cart_item_' + el.id + ' .product-subtotal .shopify-Price-amount.amount').html(priceHtml1);
            $('.cart_item_' + el.id + ' .product-price .shopify-Price-amount.amount').html(priceHtml2);

            if (typeof el.line_level_discount_allocations !== 'undefined' && el.line_level_discount_allocations.length > 0) {
                $('.cart_item_' + el.id + ' .cart-drawer__item-discount.text-small').html(el.line_level_discount_allocations[0].discount_application.title);
            }
        });

        if ($('.total_discount').length > 0) {
            $('.total_discount').remove();
        }
        if (cartContents.total_discount && $('.total_discount').length === 0) {
            const discount = '$' + (cartContents.total_discount / 100).toFixed(2) + '';
            jQuery('.cart_totals_column .cart_totals h2').after('<div style="text-align:right"><div class="total_discount">YOU SAVED: ' + discount + '</div></div>');
        }
    }*/

    let closestValue = 0;
    let closestIndex = maxRules.length - 2;
    for (var i = 0; i < maxRules.length; i++) {
        if (currentCartValue >= maxRules[i]) {
            closestValue = maxRules[i];
            closestIndex = i;
        }
    }
    if (closestIndex === maxRules.length - 1) {
        closestIndex = maxRules.length - 2;
    }

    closestValue = maxRules[closestIndex + 1];

    // vsmDebug('adding promo');
    const diff = (closestValue - currentCartValue).toFixed(2);
    const percent = (currentCartValue / maxValue * 100) < 100 ? (currentCartValue / maxValue * 100) : 100;
    //
    //let diffText = 'YOU’RE $' + diff + ' AWAY FROM $15 in saving';
    let diffText = `You are <strong>\$${diff}</strong> away from more savings`;
    // if (currentCartValue >= 100) {
    //     diffText = 'SPEND $' + diff + ' MORE TO SAVE $40';
    // }
    if (diff <= 0 && currentCartValue > 0) {
        diffText = 'YOU HAVE UNLOCKED ALL SAVINGS';
        //$('#nova-cart').addClass('has-promo');
    } else {
        $('#rebuy-cart').removeClass('has-promo');
    }

    var html = '<div class="promo-bar-container bar-2024"><div class="promo-bar-wrapper"><div class="promo-bar-text" data-value="' + percent + '">' + titleText + '</div>\n';

    if (titleText1) {
        html += `<p class="promo-bar-text" style="font-size: 1em">${titleText1}</p>`;
    }

    html += `<ul id="promo-steps">`;
    for (let i = 0; i < maxRules.length; i++) {
        if (i === 0) continue;
        let className = '';
        if (i + 1 < maxRules.length && currentCartValue < maxRules[i + 1] && currentCartValue >= maxRules[i]) {
            className = 'checked';
        }
        if (i + 1 === maxRules.length && currentCartValue >= maxRules[i]) {
            className = 'checked';
        }
        let text = '';
        if (maxRules[i] === 1) {
            text = `unlocked`;
        } else {
            text = `unlocks at \$${maxRules[i]}`;
        }
        html += `<li class="${className}">
                    <span class="percentage">${promoBonuses[i]}</span>
                    <span class="step_text">${text}</span> 
                 </li>`;
    }
    html += `</ul>`;
    for (let i = 0; i < maxRules.length; i++) {
        var percentage = maxRules[i] / maxValue * 100;
        var className = '';
        if (i + 1 < maxRules.length && currentCartValue < maxRules[i + 1] && percentage <= percent) {
            className = ' checked';
        }
        if (currentCartValue >= maxRules[i]) {
            className = 'passed';
        }
        if (i + 1 === maxRules.length && currentCartValue >= maxRules[i]) {
            className = 'checked';
        }
        if (currentCartValue >= maxRules[i] && i < maxRules.length - 1 && currentCartValue < maxRules[i + 1]) {
            className += ' nearest';
        }
        if (i === maxRules.length - 1 && currentCartValue >= maxRules[i]) {
            className += ' nearest';
        }
        html += '        <div class="progress promo-bar border-blue ' + className + '" style="width: ' + percentage + '%" max="' + percentage + '" value="' + Math.min(percent, percentage) + '" data-bonus="' + promoBonuses[i] + '"><span class="progress-val" style="width: ' + Math.min(percent, percentage) + '%"></span></div>\n';
        //html += '        <progress class="promo-bar border-blue ' + className + '" max="' + percentage + '" value="' + Math.min(percent, percentage) + '" style="width:' + percentage + '%;" data-bonus="' + promoBonuses[i] + '"> ' + percent + '% </progress>\n';
    }
    html += `
    <div class="progress-info">`;

    if (diff > 0) {
        html += `<div class="progress-title">
            My Cart Progress: <strong>\$${currentCartValue}</strong>
        </div>
        <div class="progress-subtitle">
            ${diffText}
        </div>`;
    } else {
        html += `<div class="progress-title">
            ${diffText}
        </div>`;
    }

    html += `</div>`;

    html += '    </div></div>';

    return html;
}
